// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MOBILE SCREENER STYLES
   Responsive ticker stories view for options screener
   ============================================ */

/* CSS Variables */
:root {
  --mobile-bg-primary: #000000;
  --mobile-bg-secondary: #0a0a0a;
  --mobile-surface: #1a1a1a;
  --mobile-surface-hover: #242424;
  --mobile-border: #333;
  --mobile-text-primary: #ffffff;
  --mobile-text-secondary: #b0b0b0;
  --mobile-text-muted: #666;
  --mobile-accent-blue: #218aff;
  --mobile-accent-green: #39ff5a;
  --mobile-accent-red: #ff3939;
  --mobile-accent-orange: #ff8c39;
  --mobile-accent-purple: #b968ff;
  --mobile-panel-height: 140px; /* Height for floating panel */
}

/* Remove tap highlight on mobile */
* {
  -webkit-tap-highlight-color: transparent;
}

/* ============================================
   MOBILE RESULTS CONTAINER
   ============================================ */

.mobile-results-container {
  width: 100%;
  min-height: 400px;
  background: var(--mobile-bg-primary);
  color: var(--mobile-text-primary);
  padding: env(safe-area-inset-top, 0) env(safe-area-inset-right, 0) env(safe-area-inset-bottom, 0) env(safe-area-inset-left, 0);
}

/* ============================================
   GLOBAL SIMULATION CONTROLS
   ============================================ */

.global-controls-panel {
  background: #1f2937; /* gray-800 matching table view */
  border-bottom: 1px solid var(--mobile-border);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.global-panel-title {
  font-size: 13px;
  color: var(--mobile-text-secondary);
  margin-bottom: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.global-panel-title .title-text {
  flex: 1 1;
}

.global-refresh-btn {
  padding: 8px 16px;
  background: #218aff; /* Solid blue matching table view */
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.global-refresh-btn:hover {
  background: #1a6fcc; /* Darker blue on hover */
}

.global-refresh-btn:active {
  transform: scale(0.98);
}

.global-refresh-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
}

.expiration-label {
  color: #218aff; /* Blue matching table view */
  font-weight: 700;
}

.contract-count {
  color: #218aff; /* Blue instead of green to match table view */
}

.global-control-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.global-control-row:last-child {
  margin-bottom: 0;
}

.global-control-label {
  font-size: 13px;
  color: #b0b0b0; /* Lighter gray for labels */
  min-width: 110px;
  flex-shrink: 0;
  font-weight: 500;
}

.global-control-slider {
  flex: 1 1;
  appearance: none;
  height: 8px; /* Slightly thicker to match table view */
  border-radius: 4px;
  outline: none;
  cursor: pointer;
}

.global-control-slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #218aff; /* Blue matching table view */
  cursor: pointer;
  border: 2px solid #1f2937;
}

.global-control-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #218aff; /* Blue matching table view */
  cursor: pointer;
  border: 2px solid #1f2937;
}

.global-control-value {
  font-size: 13px;
  color: #218aff; /* Blue matching table view */
  font-weight: 700;
  min-width: 70px;
  text-align: right;
}

/* Collapsible Header - Updated for Stories View */
.global-controls-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--mobile-border);
  margin-bottom: 16px;
  transition: background 0.2s;
}

.global-controls-header:hover {
  background: rgba(255, 255, 255, 0.03);
  margin: -16px -16px 16px -16px;
  padding: 16px;
  border-radius: 8px 8px 0 0;
}

.global-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.global-header-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--mobile-text-primary);
  margin: 0;
}

.global-header-info {
  font-size: 12px;
  color: #218aff;
  font-weight: 500;
}

.global-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.global-header-summary {
  font-size: 12px;
  color: #218aff;
  font-weight: 600;
}

.global-chevron {
  font-size: 18px;
  color: var(--mobile-text-muted);
  transition: transform 0.3s ease;
}

.global-chevron.expanded {
  transform: rotate(90deg);
}

/* Content Sections */
.global-controls-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.global-control-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.global-control-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.global-control-date,
.global-control-value-display {
  font-size: 14px;
  font-weight: 700;
  color: #218aff;
}

.global-slider-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.global-slider-labels {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: var(--mobile-text-muted);
}

/* Hot Buttons for Quick Selection */
.global-hot-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.global-hot-btn {
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 6px;
  border: none;
  background: #374151;
  color: #b0b0b0;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.global-hot-btn:hover {
  background: #4b5563;
  color: #fff;
}

.global-hot-btn.active {
  background: #218aff;
  color: white;
}

/* Action Buttons Row */
.global-action-buttons {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.global-action-buttons .global-refresh-btn {
  flex: 1 1;
}

.global-reset-btn {
  flex: 1 1;
  padding: 8px 16px;
  background: #374151;
  color: #b0b0b0;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.global-reset-btn:hover {
  background: #4b5563;
  color: #fff;
}

.global-reset-btn:active {
  transform: scale(0.98);
}

/* ============================================
   VIEW OPTIONS ROW (Toggle + Sort)
   ============================================ */

.view-options-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #1f2937;
  border-radius: 8px;
  margin-bottom: 16px;
  gap: 12px;
}

/* Group by Ticker Toggle */
.view-group-toggle {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.view-group-label {
  font-size: 13px;
  color: #b0b0b0;
  font-weight: 500;
  white-space: nowrap;
}

.view-toggle-switch {
  display: flex;
  background: #374151;
  border-radius: 4px;
  padding: 2px;
}

.view-toggle-option {
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  border-radius: 3px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
}

.view-toggle-option:hover {
  color: #9ca3af;
}

.view-toggle-option.active {
  background: #218aff;
  color: white;
}

/* Sort Wrapper */
.view-sort-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.view-sort-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.view-sort-select {
  padding: 5px 8px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #374151;
  border-radius: 4px;
  background: #374151;
  color: #fff;
  cursor: pointer;
  outline: none;
}

.view-sort-select:hover {
  border-color: #218aff;
}

.view-sort-select:focus {
  border-color: #218aff;
}

/* ============================================
   EXPIRATION FILTER CHIPS
   ============================================ */

.expiration-filter {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 16px;
  background: var(--mobile-bg-secondary);
  border-bottom: 1px solid var(--mobile-border);
  scrollbar-width: none; /* Firefox */
}

.expiration-filter::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

.expiration-chip {
  flex-shrink: 0;
  background: var(--mobile-surface);
  border: 1px solid var(--mobile-border);
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--mobile-text-secondary);
}

.expiration-chip.active {
  background: var(--mobile-accent-blue);
  border-color: var(--mobile-accent-blue);
  color: white;
}

.expiration-chip:active {
  transform: scale(0.95);
}

/* ============================================
   TICKER STORIES GRID
   ============================================ */

.ticker-stories-container {
  padding: 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  min-height: 300px;
}

.ticker-stories-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding-bottom: 20px;
}

.ticker-bubble {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  animation: bubbleIn 0.3s ease;
}

@keyframes bubbleIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.bubble-ring {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  padding: 3px;
  position: relative;
  transition: transform 0.2s ease;
}

.ticker-bubble:active .bubble-ring {
  transform: scale(0.95);
}

.bubble-ring.positive {
  background: linear-gradient(135deg, var(--mobile-accent-blue), var(--mobile-accent-green));
}

.bubble-ring.negative {
  background: linear-gradient(135deg, var(--mobile-accent-red), var(--mobile-accent-orange));
}

.bubble-content {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--mobile-bg-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.bubble-value {
  margin-top: 8px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.bubble-value.positive {
  color: var(--mobile-accent-green);
}

.bubble-value.negative {
  color: var(--mobile-accent-red);
}

.bubble-label {
  margin-top: 4px;
  font-size: 11px;
  color: var(--mobile-text-muted);
  text-align: center;
}

/* ============================================
   CONTRACT BUBBLES (Individual/Ungrouped Mode)
   ============================================ */

/* Contract bubble content - two lines (ticker + strike) */
.contract-bubble-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.contract-ticker {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.contract-strike {
  font-size: 10px;
  font-weight: 600;
  opacity: 0.9;
}

/* Ungrouped grid - smaller bubbles to fit more */
.ticker-stories-grid.ungrouped .ticker-bubble {
  /* Slightly smaller touch targets for denser grid */
}

.ticker-stories-grid.ungrouped .bubble-ring {
  width: 64px;
  height: 64px;
}

.ticker-stories-grid.ungrouped .bubble-value {
  font-size: 12px;
  margin-top: 6px;
}

.ticker-stories-grid.ungrouped .bubble-label {
  font-size: 10px;
}

/* ============================================
   STORY VIEW OVERLAY
   ============================================ */

.card-story-view {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000;  /* Solid black to completely cover background */
  z-index: 1000;
  display: flex;
  flex-direction: column;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.card-story-view.show {
  opacity: 1;
  visibility: visible;
}

/* Progress Bar */
.story-progress {
  display: flex;
  gap: 4px;
  padding: env(safe-area-inset-top, 12px) 12px 12px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.8), transparent);
  position: relative;
  z-index: 10;
}

.progress-segment {
  flex: 1 1;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
}

.progress-segment.active {
  background: rgba(255, 255, 255, 1);
}

.progress-fill {
  height: 100%;
  background: white;
  width: 0;
  transition: width 0.3s ease;
}

.progress-segment.active .progress-fill {
  width: 100%;
}

/* Ticker Indicator */
.ticker-indicator {
  position: absolute;
  top: env(safe-area-inset-top, 40px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 700;
  color: white;
  z-index: 20;
  letter-spacing: 1px;
}

/* Close Button */
.card-close-btn {
  position: absolute;
  top: max(env(safe-area-inset-top, 16px), 16px);
  right: 16px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(40, 40, 40, 0.9);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.4);
  color: white;
  font-size: 28px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}

.card-close-btn:hover {
  background: rgba(60, 60, 60, 0.95);
  border-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.05);
}

.card-close-btn:active {
  transform: scale(0.95);
  background: rgba(80, 80, 80, 0.95);
}

/* Card Carousel */
.card-carousel {
  flex: 1 1;
  position: relative;
  overflow: hidden;
  touch-action: pan-y;
}

.card-wrapper {
  display: flex;
  height: 100%;
  transition: transform 0.3s ease;
  will-change: transform;
}

/* ============================================
   CONTRACT CARD
   ============================================ */

.result-card-compact {
  width: 100vw;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 24px env(safe-area-inset-bottom, 40px);
  box-sizing: border-box;
}

/* Main Info */
.card-main-info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 32px;
}

.card-ticker-large {
  font-size: 48px;
  font-weight: 800;
  letter-spacing: 2px;
  color: white;
}

.card-type-badge {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
}

.badge-call {
  background: var(--mobile-accent-green);
  color: black;
}

.badge-put {
  background: var(--mobile-accent-red);
  color: white;
}

.card-expiry {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: var(--mobile-text-secondary);
  margin-top: 8px;
}

/* Key Metrics */
.key-metrics {
  background: var(--mobile-surface);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 24px;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

.metric-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.metric-label-small {
  font-size: 11px;
  color: var(--mobile-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.metric-value-large {
  font-size: 20px;
  font-weight: 700;
  color: var(--mobile-text-primary);
}

.metric-highlight {
  padding-top: 16px;
  border-top: 1px solid var(--mobile-border);
  text-align: center;
}

.gain-value {
  font-size: 32px;
  font-weight: 800;
  margin-top: 8px;
}

.gain-value.positive {
  color: var(--mobile-accent-green);
}

.gain-value.negative {
  color: var(--mobile-accent-red);
}

/* Interactive Controls */
.compact-controls {
  background: var(--mobile-surface);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
}

.control-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.control-row:last-child {
  margin-bottom: 0;
}

.control-label-inline {
  font-size: 12px;
  color: var(--mobile-text-secondary);
  min-width: 50px;
  font-weight: 600;
}

.control-slider-inline {
  flex: 1 1;
  appearance: none;
  height: 4px;
  border-radius: 2px;
  background: var(--mobile-border);
  outline: none;
}

.control-slider-inline::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--mobile-accent-blue);
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
}

.control-slider-inline::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--mobile-accent-blue);
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
}

.control-value-inline {
  font-size: 12px;
  color: var(--mobile-text-primary);
  font-weight: 700;
  min-width: 50px;
  text-align: right;
}

/* Refresh Data Button */
.refresh-data-btn {
  width: 100%;
  padding: 12px 16px;
  margin-top: 12px;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
}

.refresh-data-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.refresh-data-btn:active {
  transform: scale(0.98);
}

.refresh-data-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Greeks Bar */
.greeks-bar {
  display: flex;
  justify-content: space-between;
  background: var(--mobile-surface);
  border-radius: 12px;
  padding: 12px 16px;
}

.greek-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.greek-label {
  font-size: 10px;
  color: var(--mobile-text-muted);
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.greek-value {
  font-size: 13px;
  font-weight: 600;
  color: var(--mobile-text-primary);
}

/* ============================================
   LOADING STATES
   ============================================ */

.loading-spinner {
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top-color: var(--mobile-accent-blue);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.mobile-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 16px;
}

.mobile-loading-text {
  font-size: 14px;
  color: var(--mobile-text-secondary);
}

/* ============================================
   RESPONSIVE ADJUSTMENTS
   ============================================ */

@media (max-width: 360px) {
  .ticker-stories-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .card-ticker-large {
    font-size: 40px;
  }

  .metrics-grid {
    gap: 12px;
  }

  .metric-value-large {
    font-size: 18px;
  }

  .gain-value {
    font-size: 28px;
  }
}

@media (min-width: 768px) {
  .ticker-stories-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1024px) {
  .ticker-stories-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

/* ============================================
   UTILITY CLASSES
   ============================================ */

.text-positive {
  color: var(--mobile-accent-green);
}

.text-negative {
  color: var(--mobile-accent-red);
}

.text-muted {
  color: var(--mobile-text-muted);
}

.text-secondary {
  color: var(--mobile-text-secondary);
}

/* ========================================
   ACCORDION FORM SYSTEM
   ======================================== */

.accordion-section {
  background: var(--mobile-surface);
  border: 1px solid var(--mobile-border);
  border-radius: 12px;
  margin-bottom: 0;
  overflow: visible;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
}

.accordion-section.expanded {
  z-index: 500; /* Increased from 100 to ensure ticker dropdown appears above other cards */
  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.15);
  border-color: rgba(33, 138, 255, 0.3);
}

.accordion-section.disabled {
  opacity: 0.5;
  pointer-events: none;
  filter: grayscale(50%);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s;
}

.section-header:hover {
  background-color: rgba(33, 138, 255, 0.1);
}

/* Accordion chevron styling - matches queue-header and saved-params */
.accordion-section .chevron {
  font-size: 20px;
  color: var(--mobile-text-secondary, #b0b0b0);
  display: inline-block;
}

.section-header:active {
  transform: scale(0.99);
}

.section-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.section-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-icon {
  font-size: 14px;
  font-weight: bold;
  min-width: 20px;
  transition: color 0.3s;
}

.section-icon {
  font-size: 24px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
}

.section-summary {
  font-size: 13px;
  color: var(--mobile-accent-blue);
  font-weight: 600;
}

.chevron {
  font-size: 18px;
  color: var(--mobile-text-muted);
  transition: transform 0.3s ease;
}

.chevron.rotate-90 {
  transform: rotate(90deg);
}

.section-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  padding: 0 16px;
}

.section-content.expanded {
  max-height: 2000px;
  overflow: visible;
  padding: 0 16px 20px 16px;
}

/* Desktop: faster animations, more spacing */
@media (min-width: 769px) {
  .section-content {
    transition: max-height 0.2s ease;
  }

  .section-header {
    padding: 20px;
  }

  .section-content.expanded {
    padding: 0 20px 24px 20px;
  }
}

/* ========================================
   SLIDER COMPONENTS
   ======================================== */

.strike-slider-container,
.movement-slider-container {
  padding: 12px 0;
}

.slider-value-display {
  text-align: center;
  margin-bottom: 1.5rem;
  font-weight: 700;
  line-height: 1.2;
}

/* Strike Position Slider */
.strike-slider {
  width: 100%;
  height: 10px;
  appearance: none;
  background: linear-gradient(to right,
    #10b981 0%,    /* Green (ITM) */
    #eab308 50%,   /* Yellow (ATM) */
    #3b82f6 100%   /* Blue (OTM) */
  );
  border-radius: 5px;
  outline: none;
  cursor: pointer;
}

.strike-slider::-webkit-slider-thumb {
  appearance: none;
  width: 24px;
  height: 24px;
  background: white;
  border: 3px solid #3b82f6;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  -webkit-transition: transform 0.1s;
  transition: transform 0.1s;
}

.strike-slider::-webkit-slider-thumb:hover {
  transform: scale(1.1);
}

.strike-slider::-webkit-slider-thumb:active {
  transform: scale(1.05);
}

.strike-slider::-moz-range-thumb {
  width: 24px;
  height: 24px;
  background: white;
  border: 3px solid #3b82f6;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Stock Movement Slider */
.movement-slider {
  width: 100%;
  height: 10px;
  appearance: none;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
}

.movement-slider::-webkit-slider-thumb {
  appearance: none;
  width: 24px;
  height: 24px;
  background: white;
  border: 3px solid #10b981;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  -webkit-transition: transform 0.1s;
  transition: transform 0.1s;
}

.movement-slider::-webkit-slider-thumb:hover {
  transform: scale(1.1);
}

.movement-slider::-moz-range-thumb {
  width: 24px;
  height: 24px;
  background: white;
  border: 3px solid #10b981;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Preset Buttons */
.preset-buttons {
  display: grid;
  gap: 8px;
  margin-top: 16px;
}

.preset-buttons.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.preset-buttons.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

.preset-btn {
  padding: 12px;
  border-radius: 8px;
  background: var(--mobile-bg-secondary);
  border: 2px solid var(--mobile-border);
  font-size: 14px;
  font-weight: 600;
  color: var(--mobile-text-primary);
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.preset-btn:hover {
  border-color: var(--mobile-accent-blue);
  background: rgba(33, 138, 255, 0.1);
}

.preset-btn.selected {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  border-color: transparent;
  color: white;
  transform: scale(1.02);
}

.preset-btn:active {
  transform: scale(0.98);
}

/* ========================================
   EXPIRATION TIMEFRAME BUTTONS
   ======================================== */

.timeframe-grid {
  display: grid;
  gap: 12px;
}

.timeframe-grid.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.timeframe-grid.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

.timeframe-button {
  position: relative;
  padding: 20px 16px;
  border-radius: 12px;
  background: var(--mobile-bg-secondary);
  border: 2px solid var(--mobile-border);
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.timeframe-button:hover {
  border-color: var(--mobile-accent-blue);
  background: rgba(33, 138, 255, 0.05);
  transform: translateY(-2px);
}

.timeframe-button.selected {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  border-color: transparent;
  color: white;
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.timeframe-button:active {
  transform: scale(0.98);
}

.timeframe-icon {
  font-size: 32px;
}

.timeframe-label {
  font-size: 14px;
  font-weight: 600;
}

/* ========================================
   STRATEGY CARDS (Basic Mode)
   ======================================== */

.strategy-card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 0;
}

@media (min-width: 480px) {
  .strategy-card-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 769px) {
  .strategy-card-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
}

.strategy-card {
  position: relative;
  padding: 16px;
  border-radius: 12px;
  background: var(--mobile-bg-secondary);
  border: 2px solid var(--mobile-border);
  text-align: left;
  cursor: pointer;
  transition: all 0.3s;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  color: var(--mobile-text-primary);
}

.strategy-card:hover {
  border-color: rgba(33, 138, 255, 0.5);
  background: rgba(33, 138, 255, 0.05);
  transform: translateY(-2px);
}

.strategy-card.selected {
  background: rgba(33, 138, 255, 0.15);
  border-color: var(--mobile-accent-blue);
  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);
  transform: scale(1.02);
}

.strategy-card:active {
  transform: scale(0.98);
}

.strategy-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Info button styling */
.info-button {
  width: 20px;
  height: 20px;
  padding: 0;
  border: 1px solid var(--mobile-border);
  border-radius: 50%;
  background: transparent;
  color: var(--mobile-text-secondary);
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-button:hover {
  background: var(--mobile-accent-blue);
  color: white;
  border-color: var(--mobile-accent-blue);
}

/* Info overlay styling */
.strategy-info-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 26, 26, 0.98);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  z-index: 10;
}

.info-content {
  color: var(--mobile-text-primary);
}

.info-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: var(--mobile-bg-secondary);
  color: var(--mobile-text-secondary);
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-close:hover {
  background: var(--mobile-accent-red);
  color: white;
}

.info-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--mobile-accent-blue);
  margin: 0 0 16px 0;
}

.info-item {
  margin-bottom: 14px;
}

.info-item strong {
  display: block;
  font-size: 11px;
  color: var(--mobile-accent-blue);
  margin-bottom: 4px;
  text-transform: uppercase;
}

.info-item p {
  margin: 0;
  font-size: 12px;
  color: var(--mobile-text-secondary);
  line-height: 1.4;
}

/* Ensure strategy card has relative positioning for overlay */
.strategy-card {
  position: relative;
}

.strategy-card-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--mobile-text-primary);
  margin: 0;
}

.strategy-card-subtitle {
  font-size: 12px;
  color: var(--mobile-text-secondary);
  margin: 0;
  line-height: 1.4;
  flex: 1 1;
}

.strategy-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.strategy-tag {
  padding: 3px 8px;
  border-radius: 4px;
  background: rgba(33, 138, 255, 0.15);
  color: var(--mobile-accent-blue);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
}

.strategy-card.selected .strategy-tag {
  background: var(--mobile-accent-blue);
  color: white;
}

.timeframe-range {
  font-size: 11px;
  opacity: 0.7;
}

/* Strategy card parameter grid */
.strategy-params-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--mobile-border);
}

.param-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.param-label {
  font-size: 10px;
  text-transform: uppercase;
  opacity: 0.7;
  letter-spacing: 0.5px;
  color: var(--mobile-text-muted);
}

.param-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--mobile-text);
}

.param-value.expected-move {
  color: var(--mobile-accent-blue);
}

/* Option type badge */
.option-type-badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.option-type-badge.call {
  background: rgba(34, 197, 94, 0.2);
  color: #22c55e;
}

.option-type-badge.put {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

/* Call vs Put strategy card styling */
.strategy-card.call-strategy {
  border-color: rgba(34, 197, 94, 0.3);
}

.strategy-card.call-strategy:hover {
  border-color: rgba(34, 197, 94, 0.5);
  background: rgba(34, 197, 94, 0.05);
}

.strategy-card.put-strategy {
  border-color: rgba(239, 68, 68, 0.3);
}

.strategy-card.put-strategy:hover {
  border-color: rgba(239, 68, 68, 0.5);
  background: rgba(239, 68, 68, 0.05);
}

/* Ensure cards have minimum height for parameter display */
.strategy-card {
  min-height: 200px;
}

/* Strategy card header adjustments */
.strategy-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Strategy grid: 2 columns on desktop, 1 column on mobile */
.strategy-card-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, 1fr); /* 2 columns on desktop */
}

/* Mobile: Single column layout for better readability */
@media (max-width: 768px) {
  .strategy-card-grid {
    grid-template-columns: 1fr; /* Single column on mobile */
    gap: 12px;
  }

  /* Hide subtitle on mobile for cleaner layout */
  .strategy-card-subtitle {
    display: none;
  }

  /* Adjust card styling for mobile */
  .strategy-card {
    padding: 14px;
    min-height: auto; /* Remove height constraints */
  }

  .strategy-card-title {
    font-size: 1em;
  }

  .strategy-params-grid .param-label {
    font-size: 0.8em;
  }

  .strategy-params-grid .param-value {
    font-size: 0.9em;
  }
}

/* ========================================
   Mode Toggle (Basic/Advanced)
   ======================================== */

.mode-toggle-grid {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

@media (max-width: 640px) {
  .mode-toggle-grid {
    flex-direction: column;
  }
}

.mode-toggle-card {
  position: relative;
  padding: 16px;
  border-radius: 12px;
  background: var(--mobile-bg-secondary);
  border: 2px solid var(--mobile-border);
  text-align: left;
  cursor: pointer;
  transition: all 0.3s;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.mode-toggle-card:hover {
  border-color: rgba(33, 138, 255, 0.5);
  background: rgba(33, 138, 255, 0.05);
  transform: translateY(-2px);
}

.mode-toggle-card.selected {
  background: rgba(33, 138, 255, 0.15);
  border-color: var(--mobile-accent-blue);
  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);
  transform: scale(1.02);
}

.mode-toggle-card:active {
  transform: scale(0.98);
}

.mode-toggle-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--mobile-text-primary);
  margin: 0;
}

.mode-toggle-subtitle {
  font-size: 14px;
  color: var(--mobile-text-secondary);
  margin: 0;
  line-height: 1.4;
  opacity: 0.8;
}

.mode-toggle-card.selected .mode-toggle-title {
  color: var(--mobile-text-primary); /* Keep text white in all states */
}

/* ========================================
   SCREENER SPLIT-PANEL LAYOUT
   ======================================== */

.screener-layout-wrapper {
  display: block;
  width: 100%;
}

/* Desktop: Split panel layout */
@media (min-width: 769px) {
  .screener-layout-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-top: 20px;
  }

  .screener-left-panel {
    min-width: 0; /* Prevent grid blowout */
  }

  .screener-right-panel {
    min-width: 0; /* Prevent grid blowout */
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  /* Ensure full-width queue section spans properly on desktop */
  .queue-section-fullwidth {
    grid-column: 1 / -1; /* Span full width */
    width: 100%;
  }
}

/* Mobile: Stacked layout */
@media (max-width: 768px) {
  .screener-layout-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .screener-left-panel {
    width: 100%;
  }

  .screener-left-panel form {
    margin-bottom: 8px;
  }

  .screener-right-panel {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
}

/* Queue and Saved Parameters styling */
.queue-section {
  background: var(--mobile-surface);
  border: 1px solid #3a3a3a;
  border-radius: 12px;
  overflow: hidden; /* For smooth collapse animation */
}

/* Screener Mode Section - collapsible with chevron and blue hover */
.screener-mode-section {
  background: var(--mobile-surface);
  border: 1px solid #3a3a3a;
  border-radius: 12px;
  padding: 0;
}

.screener-mode-section .collapsible-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
  border-radius: 12px;
}

.screener-mode-section .collapsible-header:hover {
  background-color: rgba(33, 138, 255, 0.1);
}

.screener-mode-section .collapsible-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.screener-mode-section .collapsible-header-left h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--mobile-text-primary);
}

.screener-mode-section .collapsible-header .chevron {
  font-size: 20px;
  color: var(--mobile-text-secondary);
  transition: transform 0.3s ease;
  display: inline-block;
}

.screener-mode-section .collapsible-header .chevron.rotate-90 {
  transform: rotate(90deg);
}

.screener-mode-section .mode-summary {
  font-size: 14px;
  color: var(--mobile-accent-blue);
  font-weight: 600;
}

.screener-mode-section .mode-toggle-content {
  padding: 0 20px 20px 20px;
}

.saved-params-section {
  background: var(--mobile-surface);
  border: 1px solid #3a3a3a;
  border-radius: 12px;
  padding: 0; /* Remove padding, header handles it */
}

/* Saved params collapsible header - matches queue-header styling */
.saved-params-section .collapsible-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
  border-radius: 12px;
}

.saved-params-section .collapsible-header:hover {
  background-color: rgba(33, 138, 255, 0.1);
}

.saved-params-section .collapsible-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.saved-params-section .collapsible-header-left h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--mobile-text-primary);
}

.saved-params-section .collapsible-header .chevron {
  font-size: 20px;
  color: var(--mobile-text-secondary);
  transition: transform 0.3s ease;
  display: inline-block;
}

.saved-params-section .collapsible-header .chevron.rotate-90 {
  transform: rotate(90deg);
}

.saved-params-section .saved-params-count {
  font-size: 14px;
  color: var(--mobile-accent-blue);
  font-weight: 600;
}

/* When expanded, round only top corners of header */
.saved-params-section.expanded .collapsible-header {
  border-radius: 12px 12px 0 0;
}

/* Full-width queue section */
.queue-section-fullwidth {
  width: 100%;
  margin-top: 24px;
  margin-bottom: 24px;
}

/* Mobile: Reduce queue section spacing */
@media (max-width: 768px) {
  .queue-section-fullwidth {
    margin-top: 12px;
    margin-bottom: 16px;
  }
}

.queue-section-fullwidth .queue-section {
  width: 100%;
  max-width: 100%;
}

/* Queue Header - Collapsible */
.queue-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
  position: relative;
}

.queue-header:hover {
  background-color: rgba(33, 138, 255, 0.1);
}

.queue-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.queue-header-left h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--mobile-text-primary);
}

/* Chevron for queue - reuse existing chevron styles */
.queue-header .chevron {
  font-size: 20px;
  color: var(--mobile-text-secondary);
  transition: transform 0.3s ease;
  display: inline-block;
}

.queue-header .chevron.rotate-90 {
  transform: rotate(90deg);
}

/* Queue header actions */
.queue-header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* Queue Content - Collapsible */
.queue-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  padding: 0 20px;
}

.queue-content.expanded {
  max-height: 2000px;
  padding: 0 20px 20px 20px;
}

.saved-params-section h3 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 700;
  color: var(--mobile-text-primary);
}

/* Scrollable saved params container (desktop) */
.saved-params-list-container {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #444 transparent;
  padding: 0 20px 20px 20px; /* Add padding for content area */
  max-height: 550px; /* Shows ~3.5 cards (140px each + 16px gap) */
}

/* Custom scrollbar for webkit browsers */
.saved-params-list-container::-webkit-scrollbar {
  width: 6px;
}

.saved-params-list-container::-webkit-scrollbar-track {
  background: transparent;
}

.saved-params-list-container::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 3px;
}

.saved-params-list-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Saved parameters list - single column only */
.saved-params-list {
  display: grid;
  grid-template-columns: 1fr !important; /* Force single column */
  gap: 16px;
  margin-top: 12px;
}

/* Saved parameter card specific styles */
.saved-param-card {
  /* Inherits queue-card base styles */
  max-width: 100%; /* Ensure cards don't grow too large */
}

.saved-param-label {
  padding: 6px 0 2px 0;
  font-size: 11px;
  color: var(--mobile-text-secondary);
  border-top: 1px solid var(--mobile-border);
  margin-top: 6px;
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Queue items - Grid layout matching Watchlist Groups */
.queue-list {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;
}

/* Responsive grid breakpoints */
@media (min-width: 640px) {
  .queue-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .queue-list {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1280px) {
  .queue-list {
    grid-template-columns: repeat(4, 1fr);
  }
}

.queue-item {
  background: var(--mobile-bg-secondary);
  border: 1px solid var(--mobile-border);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
}

.queue-item:hover {
  background: var(--mobile-surface-hover);
  border-color: var(--mobile-accent-blue);
}

.queue-item-info {
  flex: 1 1;
}

.queue-item-label {
  font-weight: 600;
  color: var(--mobile-text-primary);
  margin-bottom: 4px;
}

.queue-item-details {
  font-size: 12px;
  color: var(--mobile-text-secondary);
}

.queue-item-actions {
  display: flex;
  gap: 8px;
}

.queue-action-btn {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid var(--mobile-border);
  background: var(--mobile-surface);
  color: var(--mobile-text-primary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.queue-action-btn:hover {
  background: var(--mobile-accent-blue);
  border-color: var(--mobile-accent-blue);
  color: white;
}

.queue-action-btn.remove {
  border-color: rgba(239, 68, 68, 0.3);
}

.queue-action-btn.remove:hover {
  background: var(--mobile-accent-red);
  border-color: var(--mobile-accent-red);
}

/* Queue Card - Strategy Card Style */
.queue-card {
  background: var(--mobile-bg-secondary);
  border: 2px solid var(--mobile-border);
  border-radius: 10px;
  padding: 12px;
  transition: all 0.3s ease;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

.queue-card:hover {
  background: var(--mobile-surface-hover);
  border-color: var(--mobile-accent-blue);
  transform: translateY(-2px);
}

/* Call/Put specific styling */
.queue-card.call-card {
  border-color: rgba(34, 197, 94, 0.3);
}

.queue-card.call-card:hover {
  border-color: rgba(34, 197, 94, 0.5);
  background: rgba(34, 197, 94, 0.05);
}

.queue-card.put-card {
  border-color: rgba(239, 68, 68, 0.3);
}

.queue-card.put-card:hover {
  border-color: rgba(239, 68, 68, 0.5);
  background: rgba(239, 68, 68, 0.05);
}

/* Queue Card Header */
.queue-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.queue-card-tickers {
  font-size: 13px;
  font-weight: 700;
  color: var(--mobile-text-primary);
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}

.queue-card-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 2x2 Parameter Grid - Matches Strategy Cards */
.queue-card-params-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--mobile-border);
  margin-bottom: 8px;
}

.queue-card-params-grid .param-item {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.queue-card-params-grid .param-label {
  font-size: 8px;
  text-transform: uppercase;
  opacity: 0.7;
  letter-spacing: 0.2px;
  color: var(--mobile-text-muted);
}

.queue-card-params-grid .param-value {
  font-size: 12px;
  font-weight: 600;
  color: var(--mobile-text-primary);
}

.queue-card-params-grid .param-value.expected-move {
  color: var(--mobile-accent-blue);
}

/* Queue Card Actions */
.queue-card-actions {
  display: flex;
  gap: 4px;
  padding-top: 8px;
  border-top: 1px solid var(--mobile-border);
}

.queue-card-actions button {
  flex: 1 1;
  padding: 4px 6px;
  font-size: 11px;
}

/* Mobile adjustments for queue */
@media (max-width: 768px) {
  .queue-header {
    padding: 12px 16px;
  }

  .detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .detail-label {
    font-size: 11px;
  }
}

/* ========================================
   INLINE ACTION BUTTONS (For buttons inside cards)
   ======================================== */

.inline-action-btn {
  padding: 6px 12px;
  font-size: 12px;
  border: 1px solid #333;
  background-color: #1a1a1a;
  color: #b0b0b0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  outline: none;
}

/* Primary variant (Load, Queue) */
.inline-action-btn.inline-action-btn-primary:hover:not(:disabled) {
  border-color: rgba(33, 138, 255, 0.5);
  background-color: rgba(33, 138, 255, 0.15);
  color: #fff;
}

.inline-action-btn.inline-action-btn-primary:active:not(:disabled) {
  background-color: rgba(33, 138, 255, 0.25);
  border-color: #218aff;
}

/* Danger variant (Delete, Remove) */
.inline-action-btn.inline-action-btn-danger:hover:not(:disabled) {
  border-color: #dc2626;
  background-color: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.inline-action-btn.inline-action-btn-danger:active:not(:disabled) {
  background-color: rgba(239, 68, 68, 0.25);
  border-color: #ef4444;
}

/* Disabled state */
.inline-action-btn:disabled,
.inline-action-btn.inline-action-btn-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Empty state */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: var(--mobile-text-muted);
}

.empty-state-icon {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.empty-state-text {
  font-size: 14px;
}

/* Save Parameter Button in Basic Form */
.save-parameter-btn {
  padding: 12px 20px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.save-parameter-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.save-parameter-btn:active {
  transform: scale(0.98);
}

/* ========================================
   FIXED BOTTOM BUTTON (Mobile)
   ======================================== */

.fixed-bottom-button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  background: rgba(10, 10, 10, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid var(--mobile-border);
  z-index: 50;
}

.inline-button {
  padding: 16px 0;
  margin-top: 24px;
}

.run-screener-btn {
  width: 100%;
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.run-screener-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

.run-screener-btn:active {
  transform: scale(0.98);
}

.run-screener-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #666;
  box-shadow: none;
}

.run-screener-btn.disabled:hover {
  transform: none;
}

.queue-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ef4444;
  color: white;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 12px;
  border: 2px solid var(--mobile-bg-primary);
  min-width: 24px;
  text-align: center;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* ========================================
   DIRECTION BUTTONS (Form)
   ======================================== */

.direction-grid {
  display: grid;
  gap: 12px;
}

.direction-grid.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.direction-btn {
  padding: 24px 16px;
  border-radius: 12px;
  background: var(--mobile-bg-secondary);
  border: 2px solid var(--mobile-border);
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-height: 120px;
}

.direction-btn:hover {
  border-color: var(--mobile-accent-blue);
  background: rgba(33, 138, 255, 0.05);
  transform: translateY(-2px);
}

.direction-btn.selected {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  border-color: transparent;
  color: white;
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.direction-btn:active {
  transform: scale(0.98);
}

/* Direction buttons with theme template styling (matches mode-toggle cards) */
.direction-btn-themed {
  padding: 24px 16px;
  border-radius: 12px;
  background: #1f2937;
  border: 2px solid #2d3748;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-height: 120px;
}

.direction-btn-themed:hover {
  border-color: rgba(33, 138, 255, 0.5);
  background: rgba(33, 138, 255, 0.05);
  transform: translateY(-2px);
}

.direction-btn-themed.selected {
  background: #218aff;
  border-color: #218aff;
  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);
  transform: scale(1.02);
}

.direction-btn-themed.selected .direction-btn-subtitle {
  color: rgba(255, 255, 255, 0.85);
  opacity: 1;
}

.direction-btn-themed:active {
  transform: scale(0.98);
}

.direction-btn-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--mobile-text-primary); /* Always white */
  margin: 0;
}

.direction-btn-subtitle {
  font-size: 14px;
  color: var(--mobile-text-secondary);
  opacity: 0.75;
  margin: 0;
}

/* ========================================
   TOUCH OPTIMIZATIONS (Mobile)
   ======================================== */

@media (max-width: 768px) {
  /* Prevent iOS zoom on input focus */
  input, select, textarea, button {
    font-size: 16px !important;
  }

  /* Larger touch targets */
  button, .button-like {
    min-height: 44px;
    min-width: 44px;
  }

  /* Prevent text selection on UI elements */
  .section-header, .preset-btn, .timeframe-button, .direction-btn {
    user-select: none;
    -webkit-user-select: none;
  }
}

/* ========================================
   DESKTOP ENHANCEMENTS
   ======================================== */

@media (min-width: 769px) {
  .accordion-section {
    margin-bottom: 16px;
  }

  .section-header {
    padding: 20px;
  }

  .slider-value-display {
    font-size: 3rem;
  }

  .strike-slider::-webkit-slider-thumb,
  .movement-slider::-webkit-slider-thumb {
    width: 20px;
    height: 20px;
  }

  .timeframe-button,
  .direction-btn {
    min-height: 140px;
  }

  .run-screener-btn {
    max-width: 400px;
    margin: 0 auto;
  }
}

/* =============================================== */
/* Instagram Stories Style Enhancements          */
/* =============================================== */

/* No-scroll constraint */
.card-story-view.no-scroll {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Grouped Progress Bar */
.story-progress-grouped {
  display: flex;
  gap: 12px;
  padding: env(safe-area-inset-top, 12px) 12px 12px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.9), transparent);
  position: relative;
  z-index: 10;
}

.ticker-progress-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}

.ticker-progress-group .ticker-label {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.ticker-progress-group .progress-bars {
  display: flex;
  gap: 2px;
}

.ticker-progress-group .progress-segment {
  flex: 1 1;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  position: relative;
  overflow: hidden;
}

.ticker-progress-group .progress-segment.active {
  background: #fff;
  box-shadow: 0 0 4px rgba(255, 255, 255, 0.5);
}

.ticker-progress-group .progress-segment.passed {
  background: rgba(255, 255, 255, 0.7);
}

/* Story Navigation Arrow Buttons - positioned below Greeks bar */
.story-nav-arrows {
  position: absolute;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  pointer-events: none;  /* Allow clicks to pass through container */
  z-index: 20;
}

.story-nav-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.6);
  background: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;  /* Enable clicks on buttons */
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.story-nav-btn:hover {
  border-color: rgba(255, 255, 255, 0.8);
  background: rgba(0, 0, 0, 0.6);
}

.story-nav-btn:active {
  transform: scale(0.95);
}

.story-nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.story-nav-btn:disabled:active {
  transform: none;
}

.story-nav-btn svg {
  width: 24px;
  height: 24px;
}

/* Card Carousel Container - No scroll */
.card-carousel-container {
  flex: 1 1;
  overflow: hidden;
  position: relative;
  min-height: 0;  /* Allow flex item to shrink below content size */
}

.story-card-wrapper {
  width: 100vw;
  height: 100%;
  max-height: 100%;  /* Constrain to parent */
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;  /* Clip any overflow */
}

/* Adjust ContractCard for no-scroll */
.card-story-view.no-scroll .result-card-compact {
  height: 100%;
  max-height: 100%;  /* Constrain to parent */
  overflow: hidden;  /* Clip any overflow - content should end at greeks-bar */
  display: flex;
  flex-direction: column;
  justify-content: space-between;  /* Distribute content evenly */
  padding-top: 20px;
  padding-bottom: env(safe-area-inset-bottom, 20px);
  box-sizing: border-box;  /* Include padding in height calc */
}

.card-story-view.no-scroll .card-main-info {
  flex-shrink: 0;
  margin-bottom: 15px;
}

.card-story-view.no-scroll .key-metrics {
  flex-shrink: 0;
  margin-bottom: 15px;
}

.card-story-view.no-scroll .simulated-gain {
  flex-shrink: 0;
  margin-bottom: 15px;
  padding: 20px;
}

.card-story-view.no-scroll .compact-controls {
  flex-shrink: 0;
  margin-bottom: 15px;
  position: relative;
  z-index: 10;  /* Ensure sliders are interactive */
}

.card-story-view.no-scroll .greeks-bar {
  flex-shrink: 0;
  margin-top: auto;
}

/* Reduce font sizes for compact layout */
@media (max-height: 700px) {
  .card-story-view.no-scroll .ticker-display {
    font-size: 36px;
  }

  .card-story-view.no-scroll .metric-label {
    font-size: 9px;
  }

  .card-story-view.no-scroll .metric-value {
    font-size: 16px;
  }

  .card-story-view.no-scroll .gain-percentage {
    font-size: 42px;
  }

  .card-story-view.no-scroll .greek-label {
    font-size: 9px;
  }

  .card-story-view.no-scroll .greek-value {
    font-size: 11px;
  }
}

/* ============================================
   MOBILE STORY VIEW FIX - AGGRESSIVE OVERRIDE
   ============================================ */

/* Lock page scroll when story view is open */
body.story-view-open,
html.story-view-open {
  overflow: hidden !important;
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;
}

@media (max-width: 768px) {
  /* Story view overlay - completely cover screen */
  .card-story-view {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    height: 100dvh !important;
    background: #000000 !important;
    z-index: 99999 !important;
    overflow: hidden !important;
  }

  .card-story-view.show {
    display: flex !important;
    flex-direction: column !important;
  }

  .card-story-view.no-scroll {
    height: 100vh !important;
    height: 100dvh !important;
    overflow: hidden !important;
  }

  /* Close button - fixed to viewport */
  .card-story-view .card-close-btn {
    position: fixed !important;
    top: 12px !important;
    right: 12px !important;
    z-index: 100000 !important;
    width: 40px !important;
    height: 40px !important;
    background: rgba(60, 60, 60, 0.95) !important;
    border: 2px solid rgba(255, 255, 255, 0.5) !important;
  }

  /* Progress bar - minimal height */
  .card-story-view .story-progress,
  .card-story-view .story-progress-grouped {
    flex-shrink: 0 !important;
    padding: 8px 12px !important;
  }

  /* Carousel container - take remaining space */
  .card-story-view .card-carousel-container {
    flex: 1 1 !important;
    min-height: 0 !important;
    overflow: hidden !important;
  }

  /* Card wrapper */
  .card-story-view .card-wrapper {
    height: 100% !important;
  }

  /* Story card wrapper */
  .card-story-view .story-card-wrapper {
    height: 100% !important;
    overflow: hidden !important;
  }

  /* Result card - constrained to fit viewport */
  .card-story-view .result-card-compact {
    height: 100% !important;
    max-height: 100% !important;
    overflow: hidden !important;
    padding: 8px 12px env(safe-area-inset-bottom, 8px) !important;
    justify-content: space-between !important;
    gap: 8px !important;
  }

  /* Compact all internal elements */
  .card-story-view .card-main-info {
    margin-bottom: 8px !important;
  }

  .card-story-view .card-ticker-large {
    font-size: 36px !important;
  }

  .card-story-view .key-metrics {
    padding: 12px !important;
    margin-bottom: 8px !important;
  }

  .card-story-view .metrics-grid {
    gap: 10px !important;
    margin-bottom: 12px !important;
  }

  .card-story-view .metric-item .metric-label-small {
    font-size: 10px !important;
  }

  .card-story-view .metric-item .metric-value-large {
    font-size: 16px !important;
  }

  .card-story-view .metric-highlight {
    padding: 10px !important;
  }

  .card-story-view .gain-value {
    font-size: 28px !important;
  }

  .card-story-view .compact-controls {
    margin-bottom: 8px !important;
    padding: 8px !important;
  }

  .card-story-view .control-row {
    margin-bottom: 6px !important;
  }

  .card-story-view .refresh-data-btn {
    padding: 8px 16px !important;
    font-size: 12px !important;
  }

  .card-story-view .greeks-bar {
    padding: 8px 12px !important;
    margin-top: auto !important;
  }
}

/* Stories View - Match GlobalSimulationControls styling */
.card-story-view .control-value-inline {
  color: #218aff;
  font-weight: 700;
  font-size: 11px;
  min-width: auto;
}

.card-story-view .control-slider-inline {
  height: 8px;
  border-radius: 4px;
}

.card-story-view .refresh-data-btn {
  background: #218aff;
  box-shadow: none;
}

.card-story-view .refresh-data-btn:hover {
  background: #1a6fcc;
  transform: none;
  box-shadow: none;
}

/* Update Mode Toggle */
.update-mode-toggle {
  display: flex;
  gap: 0;
  margin-top: 12px;
  margin-bottom: 8px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #333;
}

.update-mode-toggle .mode-btn {
  flex: 1 1;
  padding: 8px 12px;
  background: #0a0a0a;
  border: none;
  color: #b0b0b0;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.update-mode-toggle .mode-btn.active {
  background: rgba(33, 138, 255, 0.2);
  color: #fff;
}

.update-mode-toggle .mode-btn:first-child {
  border-right: 1px solid #333;
}

.update-mode-toggle .mode-btn:hover:not(.active) {
  background: rgba(255, 255, 255, 0.05);
}

/* Action Buttons Row */
.card-action-buttons {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.card-action-buttons button {
  flex: 1 1;
}

.card-action-buttons .refresh-data-btn {
  margin-top: 0;
}

.card-action-buttons .reset-btn {
  background: transparent;
  border: 1px solid #666;
  color: #b0b0b0;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.card-action-buttons .reset-btn:hover {
  border-color: #888;
  color: #fff;
}

.card-action-buttons .reset-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   FLOATING ACTION PANEL INTEGRATION
   ============================================ */

/* Adjust content padding when floating panel is present */
@media (max-width: 768px) {
  /* Ensure body doesn't interfere with fixed positioning */
  body {
    position: relative;
    overflow-x: hidden;
  }

  .screener-layout-wrapper {
    position: relative; /* Ensure fixed children can position correctly */
    padding-bottom: calc(var(--mobile-panel-height) + 20px); /* Extra padding for breathing room */
  }

  /* Hide desktop saved params panel when on mobile (mobile uses swipeable views instead) */
  .screener-right-panel {
    display: none;
  }

  /* Ensure form sections have proper spacing */
  .accordion-form-section {
    margin-bottom: 12px;
  }

  /* Style accordion checkmarks for completed sections */
  .accordion-form-section.completed .section-header::after {
    content: '✓';
    color: var(--mobile-accent-green);
    font-size: 18px;
    font-weight: bold;
    margin-left: auto;
  }

  /* Smooth collapse animation for sections */
  .accordion-form-section .section-content {
    transition: max-height 0.3s ease, opacity 0.3s ease;
  }

  .accordion-form-section.collapsed .section-content {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
  }

  /* Ensure progress indicator is visible */
  .progress-indicator {
    position: sticky;
    top: 0;
    z-index: 100;
    background: linear-gradient(
      to bottom,
      var(--mobile-bg-primary) 0%,
      var(--mobile-bg-primary) 90%,
      transparent 100%
    );
    padding: 12px 16px 16px;
    margin: -12px -16px 12px;
  }

  /* Show buttons inline within mobile form panel */
  .screener-mobile-form-panel .fixed-bottom-button {
    display: block;
    position: relative;
    padding: 16px 0;
    background: transparent;
    border-top: none;
    z-index: auto;
  }

  /* Ensure buttons container flows properly */
  .screener-mobile-form-panel .fixed-bottom-button .flex {
    flex-direction: column;
    gap: 12px;
  }

  .screener-mobile-form-panel .fixed-bottom-button button {
    width: 100%;
  }

  /* Hide fixed buttons in other mobile contexts */
  .fixed-bottom-button:not(.screener-mobile-form-panel .fixed-bottom-button) {
    display: none;
  }
}

/* ============================= */
/* Action Button Template Styles */
/* ============================= */

/* Base action button styles */
.action-btn {
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #333;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 500;
  background-color: #1f2937; /* Gray-800 like simulation settings */
  outline: none;
  position: relative;
  color: #b0b0b0;
}

/* Primary variant */
.action-btn-primary:hover:not(:disabled) {
  border-color: #218aff;
  background-color: #218aff;
  color: #fff;
}

.action-btn-primary:active:not(:disabled) {
  background-color: #1a6fcc;
  border-color: #1a6fcc;
}

/* Solid-blue run variant — desktop Run button (matches mobile .msf-cta) */
.action-btn-run-solid {
  background-color: #218aff;
  border-color: #218aff;
  color: #fff;
}

.action-btn-run-solid:hover:not(:disabled) {
  border-color: #1a6fcc;
  background-color: #1a6fcc;
  color: #fff;
}

.action-btn-run-solid:active:not(:disabled) {
  background-color: #1a6fcc;
  border-color: #1a6fcc;
}

/* Danger variant */
.action-btn-danger:hover:not(:disabled) {
  border-color: #ef4444;
  background-color: #ef4444;
  color: #fff;
}

.action-btn-danger:active:not(:disabled) {
  background-color: #dc2626;
  border-color: #dc2626;
}

/* Success variant - Uses blue like primary for Save button */
.action-btn-success:hover:not(:disabled) {
  border-color: #218aff;
  background-color: #218aff;
  color: #fff;
}

.action-btn-success:active:not(:disabled) {
  background-color: #1a6fcc;
  border-color: #1a6fcc;
}

/* Disabled state */
.action-btn:disabled,
.action-btn-disabled {
  border-color: #333;
  color: #666;
  background-color: #1f2937;
  opacity: 0.4;
  cursor: not-allowed;
}

/* Queue badge for action buttons (inline version) */
.action-btn .queue-badge-inline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  margin-left: 8px;
  background: #218aff;
  color: white;
  font-size: 11px;
  font-weight: 600;
  border-radius: 10px;
  vertical-align: middle;
}

/* Tooltip styles */
.action-btn-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  padding: 4px 12px;
  background-color: #111;
  border: 1px solid #333;
  border-radius: 4px;
  color: #b0b0b0;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.action-btn-tooltip-visible,
.action-btn:disabled:hover .action-btn-tooltip {
  opacity: 1;
}

/* Run variant - Full width run scenarios button */
.action-btn-run {
  width: 100%;
  margin-top: 16px;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 20px;
}

.action-btn-run:hover:not(:disabled) {
  border-color: #218aff;
  background-color: #218aff;
  color: #fff;
  box-shadow: 0 2px 8px rgba(33, 138, 255, 0.2);
  transform: translateY(-1px);
}

.action-btn-run:active:not(:disabled) {
  background-color: #1a6fcc;
  border-color: #1a6fcc;
  transform: scale(0.98);
}

/* Floating panel run button specific styles */
.floating-run-btn {
  width: auto;
  margin-top: 0;
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.floating-run-btn .btn-icon,
.floating-run-btn .btn-text {
  display: inline-block;
}

.floating-run-btn .spinner-small {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

/* ============================================
   MOBILE VIEW TOGGLE (Strategies / Saved Params)
   ============================================ */

/* Hidden on desktop */
.mobile-view-toggle {
  display: none;
}

@media (max-width: 768px) {
  .mobile-view-toggle {
    display: flex;
    gap: 8px;
    padding: 12px 16px;
    background: var(--mobile-surface);
    border: 1px solid var(--mobile-border);
    border-radius: 10px;
    margin-bottom: 12px;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .view-toggle-btn {
    flex: 1 1;
    padding: 10px 16px;
    border: 2px solid var(--mobile-border);
    background: transparent;
    border-radius: 6px;
    color: var(--mobile-text-secondary);
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .view-toggle-btn:hover {
    border-color: rgba(33, 138, 255, 0.5);
  }

  .view-toggle-btn.active {
    background: rgba(33, 138, 255, 0.15);
    border-color: var(--mobile-accent-blue);
    color: var(--mobile-text-primary);
  }

  .view-toggle-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 6px;
    margin-left: 6px;
    background: var(--mobile-accent-blue);
    color: white;
    font-size: 11px;
    font-weight: 600;
    border-radius: 10px;
  }

  .swipe-hint {
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 10px;
    color: var(--mobile-text-muted);
    opacity: 0.7;
  }
}

/* ============================================
   MOBILE SWIPEABLE VIEWS CONTAINER
   ============================================ */

.mobile-swipeable-container {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  /* Remove negative margin/padding that was causing misalignment */
}

.mobile-swipeable-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

.mobile-view-panel {
  flex: 0 0 100%;
  scroll-snap-align: start;
  min-width: 100%;
  box-sizing: border-box;
}

/* Mobile form panel styling */
.screener-mobile-form-panel {
  /* No extra padding - let content align with toggle */
}

/* Mobile saved params panel styling */
.screener-mobile-saved-panel {
  padding-left: 8px;
}

.screener-mobile-saved-panel .saved-params-section {
  background: var(--mobile-surface);
  border: 1px solid var(--mobile-border);
  border-radius: 12px;
  padding: 0;
  min-height: auto;
}

/* Compact saved params styling (matches accordion sections) */
.saved-params-section.compact {
  background: var(--mobile-surface);
  border: 1px solid var(--mobile-border);
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
}

.saved-params-section.compact .collapsible-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s;
}

.saved-params-section.compact .collapsible-header:hover {
  background: rgba(255, 255, 255, 0.03);
}

.saved-params-section.compact .collapsible-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.saved-params-section.compact .collapsible-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--mobile-text-primary);
}

.saved-params-section.compact .saved-params-count {
  font-size: 13px;
  color: var(--mobile-accent-blue);
  font-weight: 600;
}

.saved-params-section.compact .chevron {
  font-size: 18px;
  color: var(--mobile-text-muted);
  transition: transform 0.3s ease;
}

.saved-params-section.compact.expanded {
  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.15);
  border-color: rgba(33, 138, 255, 0.3);
}

.saved-params-section.compact .saved-params-list {
  padding: 0 16px 16px 16px;
}

.saved-params-section.compact .empty-state {
  padding: 24px 16px;
}

/* ========================================
   INTERMEDIATE MODE PRESET CARDS
   ======================================== */

/* Preset grid layout */
.intermediate-preset-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 12px;
}

/* Mobile: 2 columns */
@media (max-width: 768px) {
  .intermediate-preset-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
}

/* Small mobile: still 2 columns but tighter */
@media (max-width: 400px) {
  .intermediate-preset-grid {
    gap: 8px;
  }
}

/* Preset card base styles */
.intermediate-preset-card {
  position: relative;
  padding: 14px 12px;
  border-radius: 10px;
  border: 2px solid #2d3748;
  background: #1f2937;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  min-height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: inherit;
  color: var(--mobile-text-primary);
}

.intermediate-preset-card:hover {
  border-color: rgba(33, 138, 255, 0.5);
  background: rgba(33, 138, 255, 0.05);
  transform: translateY(-2px);
}

.intermediate-preset-card.selected {
  border-color: #218aff;
  background: #218aff;
  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);
}

.intermediate-preset-card.selected .preset-card-description {
  color: rgba(255, 255, 255, 0.85);
}

.intermediate-preset-card:active {
  transform: scale(0.98);
}

/* Preset card content */
.preset-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.preset-card-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--mobile-text-primary);
  line-height: 1.2;
}

.preset-card-description {
  font-size: 12px;
  color: var(--mobile-text-secondary);
  font-weight: 500;
}

/* Sentiment color coding for stock move presets */
.intermediate-preset-card.sentiment-bullish {
  border-color: rgba(34, 197, 94, 0.3);
}

.intermediate-preset-card.sentiment-bullish:hover {
  border-color: rgba(34, 197, 94, 0.5);
  background: rgba(34, 197, 94, 0.05);
}

.intermediate-preset-card.sentiment-bullish.selected {
  border-color: #22c55e;
  background: rgba(34, 197, 94, 0.15);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
}

.intermediate-preset-card.sentiment-bearish {
  border-color: rgba(239, 68, 68, 0.3);
}

.intermediate-preset-card.sentiment-bearish:hover {
  border-color: rgba(239, 68, 68, 0.5);
  background: rgba(239, 68, 68, 0.05);
}

.intermediate-preset-card.sentiment-bearish.selected {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.15);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

/* Info button wrapper */
.preset-info-wrapper {
  position: absolute;
  top: 6px;
  right: 6px;
}

.preset-info-button {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: var(--mobile-text-secondary);
  cursor: pointer;
  transition: all 0.2s;
  font-style: italic;
}

.preset-info-button:hover {
  background: rgba(33, 138, 255, 0.2);
  border-color: rgba(33, 138, 255, 0.5);
  color: var(--mobile-accent-blue);
}

/* Tooltip overlay */
.preset-tooltip-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.preset-tooltip-content {
  background: #1f2937;
  border-radius: 12px;
  padding: 20px;
  max-width: 320px;
  position: relative;
  border: 1px solid var(--mobile-border);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.preset-tooltip-content p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--mobile-text-secondary);
}

.preset-tooltip-close {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 20px;
  color: var(--mobile-text-muted);
  cursor: pointer;
  transition: color 0.2s;
  line-height: 1;
}

.preset-tooltip-close:hover {
  color: var(--mobile-text-primary);
}

/* Section helper text */
.section-helper-text {
  font-size: 13px;
  color: var(--mobile-text-secondary);
  margin: 0 0 8px 0;
  font-style: italic;
}

/* Mode toggle grid for 3 modes */
.mode-toggle-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

@media (max-width: 768px) {
  .mode-toggle-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/MobileScreener.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;EACrB,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B,EAAE,8BAA8B;AAC9D;;AAEA,mCAAmC;AACnC;EACE,wCAAwC;AAC1C;;AAEA;;iDAEiD;;AAEjD;EACE,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,iCAAiC;EACjC,8HAA8H;AAChI;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB,EAAE,iCAAiC;EACtD,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,mBAAmB,EAAE,mCAAmC;EACxD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,6BAA6B;EAC7C,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,8CAA8C;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,4BAA4B;EAC5C,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EAEP,gBAAgB;EAChB,WAAW,EAAE,yCAAyC;EACtD,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB,EAAE,6BAA6B;EAClD,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB,EAAE,6BAA6B;EAClD,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,6BAA6B;EAC7C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,6CAA6C;EAC7C,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,+BAA+B;AACjC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,sCAAsC;EACtC,6CAA6C;EAC7C,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,aAAa,EAAE,mBAAmB;AACpC;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB,GAAG,+CAA+C;EACrE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;EACR,iDAAiD;EACjD,oEAAoE;EACpE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,mCAAmC;EACnC,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;;iDAEiD;;AAEjD;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EAEP,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;iDAEiD;;AAEjD;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;6CAE6C;;AAE7C;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY,EAAE,2EAA2E;EACzF,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sEAAsE;AACtE;EACE,eAAe;EACf,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;6CAE6C;;AAE7C;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB;;;;GAIC;EACD,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,kCAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,kCAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,uCAAuC;AACzC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,sCAAsC;EACtC,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,SAAS;EACT,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA,2DAA2D;AAC3D;EACE,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,SAAS;EACT,qCAAqC,EAAE,yBAAyB;AAClE;;AAEA,wDAAwD;AACxD;EACE;IACE,0BAA0B,EAAE,4BAA4B;IACxD,SAAS;EACX;;EAEA,+CAA+C;EAC/C;IACE,aAAa;EACf;;EAEA,mCAAmC;EACnC;IACE,aAAa;IACb,gBAAgB,EAAE,8BAA8B;EAClD;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iCAAiC,EAAE,kCAAkC;AACvE;;AAEA;;6CAE6C;;AAE7C;EACE,cAAc;EACd,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,YAAY,EAAE,yBAAyB;EACzC;;EAEA;IACE,YAAY,EAAE,yBAAyB;IACvC,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,8DAA8D;EAC9D;IACE,mBAAmB,EAAE,oBAAoB;IACzC,WAAW;EACb;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA,uCAAuC;AACvC;EACE,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA,oEAAoE;AACpE;EACE,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,UAAU,EAAE,sCAAsC;AACpD;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,mCAAmC;EACnC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,gBAAgB;EAChB,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;EACjC,yBAAyB,EAAE,iCAAiC;EAC5D,iBAAiB,EAAE,6CAA6C;AAClE;;AAEA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,qCAAqC,EAAE,wBAAwB;EAC/D,SAAS;EACT,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,oCAAoC;EACpC,eAAe,EAAE,sCAAsC;AACzD;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mCAAmC;EACnC,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,iCAAiC;EACjC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;6CAE6C;;AAE7C;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;EACrB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;6CAE6C;;AAE7C;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,6DAA6D;EAC7D,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;EACtC,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC,EAAE,iBAAiB;EACpD,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,aAAa;EACb,SAAS;AACX;;AAEA;;6CAE6C;;AAE7C;EACE,oCAAoC;EACpC;IACE,0BAA0B;EAC5B;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,0CAA0C;EAC1C;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;AACF;;AAEA;;6CAE6C;;AAE7C;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA,oDAAoD;AACpD,kDAAkD;AAClD,oDAAoD;;AAEpD,yBAAyB;AACzB;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,iDAAiD;EACjD,oEAAoE;EACpE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,oDAAoD;EACpD,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,oBAAoB,GAAG,2CAA2C;EAClE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB,GAAG,6BAA6B;EACpD,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa,GAAG,iDAAiD;AACnE;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB,GAAG,wBAAwB;EAC3C,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB,GAAG,sBAAsB;AAC3C;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,gBAAgB,GAAG,wBAAwB;EAC3C,gBAAgB,GAAG,yDAAyD;EAC5E,aAAa;EACb,sBAAsB;EACtB,8BAA8B,GAAG,8BAA8B;EAC/D,iBAAiB;EACjB,iDAAiD;EACjD,sBAAsB,GAAG,mCAAmC;AAC9D;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,WAAW,GAAG,mCAAmC;AACnD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;iDAEiD;;AAEjD,6CAA6C;AAC7C;;EAEE,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;EACjD;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,8BAA8B;IAC9B,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;IACxB,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA,qCAAqC;EACrC;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,6CAA6C;IAC7C,qDAAqD;EACvD;;EAEA,kCAAkC;EAClC;;IAEE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA,8CAA8C;EAC9C;IACE,oBAAkB;IAClB,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA,iBAAiB;EACjB;IACE,uBAAuB;EACzB;;EAEA,uBAAuB;EACvB;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA,8CAA8C;EAC9C;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,6DAA6D;IAC7D,yCAAyC;IACzC,mBAAmB;EACrB;;EAEA,kCAAkC;EAClC;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF;;AAEA,0DAA0D;AAC1D;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD,0DAA0D;AAC1D;EACE,yDAAyD;EACzD;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB,EAAE,iDAAiD;IACrE,uDAAuD,EAAE,qCAAqC;EAChG;;EAEA,yFAAyF;EACzF;IACE,aAAa;EACf;;EAEA,6CAA6C;EAC7C;IACE,mBAAmB;EACrB;;EAEA,sDAAsD;EACtD;IACE,YAAY;IACZ,iCAAiC;IACjC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,2CAA2C;EAC3C;IACE,mDAAmD;EACrD;;EAEA;IACE,aAAa;IACb,UAAU;IACV,gBAAgB;EAClB;;EAEA,yCAAyC;EACzC;IACE,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ;;;;;KAKC;IACD,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA,iDAAiD;EACjD;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;EACf;;EAEA,4CAA4C;EAC5C;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA,gDAAgD;EAChD;IACE,aAAa;EACf;AACF;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;;AAElC,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB,EAAE,sCAAsC;EACjE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,0EAA0E;AAC1E;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;;EAEE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;;iDAEiD;;AAEjD,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,iCAAiC;IACjC,sCAAsC;IACtC,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,sCAAsC;IACtC,uBAAuB;IACvB,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,oCAAoC;IACpC,uCAAuC;IACvC,iCAAiC;EACnC;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,qCAAqC;IACrC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf,+BAA+B;IAC/B,YAAY;EACd;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB,EAAE,YAAY;EACnC,iEAAiE;AACnE;;AAEA;EACE,aAAa,EAAE,mBAAmB;AACpC;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,qDAAqD;AACvD;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;6CAE6C;;AAE7C,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,QAAQ;EACV;AACF;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":["/* ============================================\n   MOBILE SCREENER STYLES\n   Responsive ticker stories view for options screener\n   ============================================ */\n\n/* CSS Variables */\n:root {\n  --mobile-bg-primary: #000000;\n  --mobile-bg-secondary: #0a0a0a;\n  --mobile-surface: #1a1a1a;\n  --mobile-surface-hover: #242424;\n  --mobile-border: #333;\n  --mobile-text-primary: #ffffff;\n  --mobile-text-secondary: #b0b0b0;\n  --mobile-text-muted: #666;\n  --mobile-accent-blue: #218aff;\n  --mobile-accent-green: #39ff5a;\n  --mobile-accent-red: #ff3939;\n  --mobile-accent-orange: #ff8c39;\n  --mobile-accent-purple: #b968ff;\n  --mobile-panel-height: 140px; /* Height for floating panel */\n}\n\n/* Remove tap highlight on mobile */\n* {\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* ============================================\n   MOBILE RESULTS CONTAINER\n   ============================================ */\n\n.mobile-results-container {\n  width: 100%;\n  min-height: 400px;\n  background: var(--mobile-bg-primary);\n  color: var(--mobile-text-primary);\n  padding: env(safe-area-inset-top, 0) env(safe-area-inset-right, 0) env(safe-area-inset-bottom, 0) env(safe-area-inset-left, 0);\n}\n\n/* ============================================\n   GLOBAL SIMULATION CONTROLS\n   ============================================ */\n\n.global-controls-panel {\n  background: #1f2937; /* gray-800 matching table view */\n  border-bottom: 1px solid var(--mobile-border);\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.global-panel-title {\n  font-size: 13px;\n  color: var(--mobile-text-secondary);\n  margin-bottom: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.global-panel-title .title-text {\n  flex: 1;\n}\n\n.global-refresh-btn {\n  padding: 8px 16px;\n  background: #218aff; /* Solid blue matching table view */\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.global-refresh-btn:hover {\n  background: #1a6fcc; /* Darker blue on hover */\n}\n\n.global-refresh-btn:active {\n  transform: scale(0.98);\n}\n\n.global-refresh-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.expiration-label {\n  color: #218aff; /* Blue matching table view */\n  font-weight: 700;\n}\n\n.contract-count {\n  color: #218aff; /* Blue instead of green to match table view */\n}\n\n.global-control-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.global-control-row:last-child {\n  margin-bottom: 0;\n}\n\n.global-control-label {\n  font-size: 13px;\n  color: #b0b0b0; /* Lighter gray for labels */\n  min-width: 110px;\n  flex-shrink: 0;\n  font-weight: 500;\n}\n\n.global-control-slider {\n  flex: 1;\n  -webkit-appearance: none;\n  appearance: none;\n  height: 8px; /* Slightly thicker to match table view */\n  border-radius: 4px;\n  outline: none;\n  cursor: pointer;\n}\n\n.global-control-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #218aff; /* Blue matching table view */\n  cursor: pointer;\n  border: 2px solid #1f2937;\n}\n\n.global-control-slider::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #218aff; /* Blue matching table view */\n  cursor: pointer;\n  border: 2px solid #1f2937;\n}\n\n.global-control-value {\n  font-size: 13px;\n  color: #218aff; /* Blue matching table view */\n  font-weight: 700;\n  min-width: 70px;\n  text-align: right;\n}\n\n/* Collapsible Header - Updated for Stories View */\n.global-controls-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--mobile-border);\n  margin-bottom: 16px;\n  transition: background 0.2s;\n}\n\n.global-controls-header:hover {\n  background: rgba(255, 255, 255, 0.03);\n  margin: -16px -16px 16px -16px;\n  padding: 16px;\n  border-radius: 8px 8px 0 0;\n}\n\n.global-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.global-header-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--mobile-text-primary);\n  margin: 0;\n}\n\n.global-header-info {\n  font-size: 12px;\n  color: #218aff;\n  font-weight: 500;\n}\n\n.global-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.global-header-summary {\n  font-size: 12px;\n  color: #218aff;\n  font-weight: 600;\n}\n\n.global-chevron {\n  font-size: 18px;\n  color: var(--mobile-text-muted);\n  transition: transform 0.3s ease;\n}\n\n.global-chevron.expanded {\n  transform: rotate(90deg);\n}\n\n/* Content Sections */\n.global-controls-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.global-control-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.global-control-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.global-control-date,\n.global-control-value-display {\n  font-size: 14px;\n  font-weight: 700;\n  color: #218aff;\n}\n\n.global-slider-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.global-slider-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  color: var(--mobile-text-muted);\n}\n\n/* Hot Buttons for Quick Selection */\n.global-hot-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.global-hot-btn {\n  padding: 6px 10px;\n  font-size: 12px;\n  border-radius: 6px;\n  border: none;\n  background: #374151;\n  color: #b0b0b0;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-weight: 500;\n}\n\n.global-hot-btn:hover {\n  background: #4b5563;\n  color: #fff;\n}\n\n.global-hot-btn.active {\n  background: #218aff;\n  color: white;\n}\n\n/* Action Buttons Row */\n.global-action-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.global-action-buttons .global-refresh-btn {\n  flex: 1;\n}\n\n.global-reset-btn {\n  flex: 1;\n  padding: 8px 16px;\n  background: #374151;\n  color: #b0b0b0;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.global-reset-btn:hover {\n  background: #4b5563;\n  color: #fff;\n}\n\n.global-reset-btn:active {\n  transform: scale(0.98);\n}\n\n/* ============================================\n   VIEW OPTIONS ROW (Toggle + Sort)\n   ============================================ */\n\n.view-options-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 16px;\n  background: #1f2937;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  gap: 12px;\n}\n\n/* Group by Ticker Toggle */\n.view-group-toggle {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.view-group-label {\n  font-size: 13px;\n  color: #b0b0b0;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.view-toggle-switch {\n  display: flex;\n  background: #374151;\n  border-radius: 4px;\n  padding: 2px;\n}\n\n.view-toggle-option {\n  padding: 5px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  border: none;\n  border-radius: 3px;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.view-toggle-option:hover {\n  color: #9ca3af;\n}\n\n.view-toggle-option.active {\n  background: #218aff;\n  color: white;\n}\n\n/* Sort Wrapper */\n.view-sort-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n\n.view-sort-label {\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.view-sort-select {\n  padding: 5px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid #374151;\n  border-radius: 4px;\n  background: #374151;\n  color: #fff;\n  cursor: pointer;\n  outline: none;\n}\n\n.view-sort-select:hover {\n  border-color: #218aff;\n}\n\n.view-sort-select:focus {\n  border-color: #218aff;\n}\n\n/* ============================================\n   EXPIRATION FILTER CHIPS\n   ============================================ */\n\n.expiration-filter {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 12px 16px;\n  background: var(--mobile-bg-secondary);\n  border-bottom: 1px solid var(--mobile-border);\n  scrollbar-width: none; /* Firefox */\n}\n\n.expiration-filter::-webkit-scrollbar {\n  display: none; /* Chrome, Safari */\n}\n\n.expiration-chip {\n  flex-shrink: 0;\n  background: var(--mobile-surface);\n  border: 1px solid var(--mobile-border);\n  padding: 6px 14px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--mobile-text-secondary);\n}\n\n.expiration-chip.active {\n  background: var(--mobile-accent-blue);\n  border-color: var(--mobile-accent-blue);\n  color: white;\n}\n\n.expiration-chip:active {\n  transform: scale(0.95);\n}\n\n/* ============================================\n   TICKER STORIES GRID\n   ============================================ */\n\n.ticker-stories-container {\n  padding: 20px;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  min-height: 300px;\n}\n\n.ticker-stories-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  padding-bottom: 20px;\n}\n\n.ticker-bubble {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  animation: bubbleIn 0.3s ease;\n}\n\n@keyframes bubbleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.bubble-ring {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  padding: 3px;\n  position: relative;\n  transition: transform 0.2s ease;\n}\n\n.ticker-bubble:active .bubble-ring {\n  transform: scale(0.95);\n}\n\n.bubble-ring.positive {\n  background: linear-gradient(135deg, var(--mobile-accent-blue), var(--mobile-accent-green));\n}\n\n.bubble-ring.negative {\n  background: linear-gradient(135deg, var(--mobile-accent-red), var(--mobile-accent-orange));\n}\n\n.bubble-content {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: var(--mobile-bg-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.bubble-value {\n  margin-top: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.bubble-value.positive {\n  color: var(--mobile-accent-green);\n}\n\n.bubble-value.negative {\n  color: var(--mobile-accent-red);\n}\n\n.bubble-label {\n  margin-top: 4px;\n  font-size: 11px;\n  color: var(--mobile-text-muted);\n  text-align: center;\n}\n\n/* ============================================\n   CONTRACT BUBBLES (Individual/Ungrouped Mode)\n   ============================================ */\n\n/* Contract bubble content - two lines (ticker + strike) */\n.contract-bubble-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n}\n\n.contract-ticker {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.contract-strike {\n  font-size: 10px;\n  font-weight: 600;\n  opacity: 0.9;\n}\n\n/* Ungrouped grid - smaller bubbles to fit more */\n.ticker-stories-grid.ungrouped .ticker-bubble {\n  /* Slightly smaller touch targets for denser grid */\n}\n\n.ticker-stories-grid.ungrouped .bubble-ring {\n  width: 64px;\n  height: 64px;\n}\n\n.ticker-stories-grid.ungrouped .bubble-value {\n  font-size: 12px;\n  margin-top: 6px;\n}\n\n.ticker-stories-grid.ungrouped .bubble-label {\n  font-size: 10px;\n}\n\n/* ============================================\n   STORY VIEW OVERLAY\n   ============================================ */\n\n.card-story-view {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #000000;  /* Solid black to completely cover background */\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\n.card-story-view.show {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Progress Bar */\n.story-progress {\n  display: flex;\n  gap: 4px;\n  padding: env(safe-area-inset-top, 12px) 12px 12px;\n  background: linear-gradient(to bottom, rgba(0,0,0,0.8), transparent);\n  position: relative;\n  z-index: 10;\n}\n\n.progress-segment {\n  flex: 1;\n  height: 3px;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-segment.active {\n  background: rgba(255, 255, 255, 1);\n}\n\n.progress-fill {\n  height: 100%;\n  background: white;\n  width: 0;\n  transition: width 0.3s ease;\n}\n\n.progress-segment.active .progress-fill {\n  width: 100%;\n}\n\n/* Ticker Indicator */\n.ticker-indicator {\n  position: absolute;\n  top: env(safe-area-inset-top, 40px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(10px);\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 700;\n  color: white;\n  z-index: 20;\n  letter-spacing: 1px;\n}\n\n/* Close Button */\n.card-close-btn {\n  position: absolute;\n  top: max(env(safe-area-inset-top, 16px), 16px);\n  right: 16px;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: rgba(40, 40, 40, 0.9);\n  backdrop-filter: blur(10px);\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  color: white;\n  font-size: 28px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 100;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n}\n\n.card-close-btn:hover {\n  background: rgba(60, 60, 60, 0.95);\n  border-color: rgba(255, 255, 255, 0.6);\n  transform: scale(1.05);\n}\n\n.card-close-btn:active {\n  transform: scale(0.95);\n  background: rgba(80, 80, 80, 0.95);\n}\n\n/* Card Carousel */\n.card-carousel {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  touch-action: pan-y;\n}\n\n.card-wrapper {\n  display: flex;\n  height: 100%;\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n/* ============================================\n   CONTRACT CARD\n   ============================================ */\n\n.result-card-compact {\n  width: 100vw;\n  height: 100%;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 40px 24px env(safe-area-inset-bottom, 40px);\n  box-sizing: border-box;\n}\n\n/* Main Info */\n.card-main-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 32px;\n}\n\n.card-ticker-large {\n  font-size: 48px;\n  font-weight: 800;\n  letter-spacing: 2px;\n  color: white;\n}\n\n.card-type-badge {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n.badge-call {\n  background: var(--mobile-accent-green);\n  color: black;\n}\n\n.badge-put {\n  background: var(--mobile-accent-red);\n  color: white;\n}\n\n.card-expiry {\n  width: 100%;\n  text-align: center;\n  font-size: 14px;\n  color: var(--mobile-text-secondary);\n  margin-top: 8px;\n}\n\n/* Key Metrics */\n.key-metrics {\n  background: var(--mobile-surface);\n  border-radius: 16px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.metric-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.metric-label-small {\n  font-size: 11px;\n  color: var(--mobile-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.metric-value-large {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--mobile-text-primary);\n}\n\n.metric-highlight {\n  padding-top: 16px;\n  border-top: 1px solid var(--mobile-border);\n  text-align: center;\n}\n\n.gain-value {\n  font-size: 32px;\n  font-weight: 800;\n  margin-top: 8px;\n}\n\n.gain-value.positive {\n  color: var(--mobile-accent-green);\n}\n\n.gain-value.negative {\n  color: var(--mobile-accent-red);\n}\n\n/* Interactive Controls */\n.compact-controls {\n  background: var(--mobile-surface);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.control-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.control-row:last-child {\n  margin-bottom: 0;\n}\n\n.control-label-inline {\n  font-size: 12px;\n  color: var(--mobile-text-secondary);\n  min-width: 50px;\n  font-weight: 600;\n}\n\n.control-slider-inline {\n  flex: 1;\n  -webkit-appearance: none;\n  appearance: none;\n  height: 4px;\n  border-radius: 2px;\n  background: var(--mobile-border);\n  outline: none;\n}\n\n.control-slider-inline::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--mobile-accent-blue);\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);\n}\n\n.control-slider-inline::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--mobile-accent-blue);\n  cursor: pointer;\n  border: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);\n}\n\n.control-value-inline {\n  font-size: 12px;\n  color: var(--mobile-text-primary);\n  font-weight: 700;\n  min-width: 50px;\n  text-align: right;\n}\n\n/* Refresh Data Button */\n.refresh-data-btn {\n  width: 100%;\n  padding: 12px 16px;\n  margin-top: 12px;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);\n}\n\n.refresh-data-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.refresh-data-btn:active {\n  transform: scale(0.98);\n}\n\n.refresh-data-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Greeks Bar */\n.greeks-bar {\n  display: flex;\n  justify-content: space-between;\n  background: var(--mobile-surface);\n  border-radius: 12px;\n  padding: 12px 16px;\n}\n\n.greek-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.greek-label {\n  font-size: 10px;\n  color: var(--mobile-text-muted);\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.greek-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--mobile-text-primary);\n}\n\n/* ============================================\n   LOADING STATES\n   ============================================ */\n\n.loading-spinner {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  border: 3px solid rgba(255, 255, 255, 0.2);\n  border-top-color: var(--mobile-accent-blue);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.mobile-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  gap: 16px;\n}\n\n.mobile-loading-text {\n  font-size: 14px;\n  color: var(--mobile-text-secondary);\n}\n\n/* ============================================\n   RESPONSIVE ADJUSTMENTS\n   ============================================ */\n\n@media (max-width: 360px) {\n  .ticker-stories-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .card-ticker-large {\n    font-size: 40px;\n  }\n\n  .metrics-grid {\n    gap: 12px;\n  }\n\n  .metric-value-large {\n    font-size: 18px;\n  }\n\n  .gain-value {\n    font-size: 28px;\n  }\n}\n\n@media (min-width: 768px) {\n  .ticker-stories-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .ticker-stories-grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n/* ============================================\n   UTILITY CLASSES\n   ============================================ */\n\n.text-positive {\n  color: var(--mobile-accent-green);\n}\n\n.text-negative {\n  color: var(--mobile-accent-red);\n}\n\n.text-muted {\n  color: var(--mobile-text-muted);\n}\n\n.text-secondary {\n  color: var(--mobile-text-secondary);\n}\n\n/* ========================================\n   ACCORDION FORM SYSTEM\n   ======================================== */\n\n.accordion-section {\n  background: var(--mobile-surface);\n  border: 1px solid var(--mobile-border);\n  border-radius: 12px;\n  margin-bottom: 0;\n  overflow: visible;\n  position: relative;\n  z-index: 1;\n  transition: all 0.3s ease;\n}\n\n.accordion-section.expanded {\n  z-index: 500; /* Increased from 100 to ensure ticker dropdown appears above other cards */\n  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.15);\n  border-color: rgba(33, 138, 255, 0.3);\n}\n\n.accordion-section.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  filter: grayscale(50%);\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.2s;\n}\n\n.section-header:hover {\n  background-color: rgba(33, 138, 255, 0.1);\n}\n\n/* Accordion chevron styling - matches queue-header and saved-params */\n.accordion-section .chevron {\n  font-size: 20px;\n  color: var(--mobile-text-secondary, #b0b0b0);\n  display: inline-block;\n}\n\n.section-header:active {\n  transform: scale(0.99);\n}\n\n.section-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.section-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.status-icon {\n  font-size: 14px;\n  font-weight: bold;\n  min-width: 20px;\n  transition: color 0.3s;\n}\n\n.section-icon {\n  font-size: 24px;\n}\n\n.section-title {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.section-summary {\n  font-size: 13px;\n  color: var(--mobile-accent-blue);\n  font-weight: 600;\n}\n\n.chevron {\n  font-size: 18px;\n  color: var(--mobile-text-muted);\n  transition: transform 0.3s ease;\n}\n\n.chevron.rotate-90 {\n  transform: rotate(90deg);\n}\n\n.section-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n  padding: 0 16px;\n}\n\n.section-content.expanded {\n  max-height: 2000px;\n  overflow: visible;\n  padding: 0 16px 20px 16px;\n}\n\n/* Desktop: faster animations, more spacing */\n@media (min-width: 769px) {\n  .section-content {\n    transition: max-height 0.2s ease;\n  }\n\n  .section-header {\n    padding: 20px;\n  }\n\n  .section-content.expanded {\n    padding: 0 20px 24px 20px;\n  }\n}\n\n/* ========================================\n   SLIDER COMPONENTS\n   ======================================== */\n\n.strike-slider-container,\n.movement-slider-container {\n  padding: 12px 0;\n}\n\n.slider-value-display {\n  text-align: center;\n  margin-bottom: 1.5rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n/* Strike Position Slider */\n.strike-slider {\n  width: 100%;\n  height: 10px;\n  appearance: none;\n  background: linear-gradient(to right,\n    #10b981 0%,    /* Green (ITM) */\n    #eab308 50%,   /* Yellow (ATM) */\n    #3b82f6 100%   /* Blue (OTM) */\n  );\n  border-radius: 5px;\n  outline: none;\n  cursor: pointer;\n}\n\n.strike-slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 24px;\n  height: 24px;\n  background: white;\n  border: 3px solid #3b82f6;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  transition: transform 0.1s;\n}\n\n.strike-slider::-webkit-slider-thumb:hover {\n  transform: scale(1.1);\n}\n\n.strike-slider::-webkit-slider-thumb:active {\n  transform: scale(1.05);\n}\n\n.strike-slider::-moz-range-thumb {\n  width: 24px;\n  height: 24px;\n  background: white;\n  border: 3px solid #3b82f6;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n/* Stock Movement Slider */\n.movement-slider {\n  width: 100%;\n  height: 10px;\n  appearance: none;\n  border-radius: 5px;\n  outline: none;\n  cursor: pointer;\n}\n\n.movement-slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 24px;\n  height: 24px;\n  background: white;\n  border: 3px solid #10b981;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  transition: transform 0.1s;\n}\n\n.movement-slider::-webkit-slider-thumb:hover {\n  transform: scale(1.1);\n}\n\n.movement-slider::-moz-range-thumb {\n  width: 24px;\n  height: 24px;\n  background: white;\n  border: 3px solid #10b981;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n/* Preset Buttons */\n.preset-buttons {\n  display: grid;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.preset-buttons.grid-cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.preset-buttons.grid-cols-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.preset-btn {\n  padding: 12px;\n  border-radius: 8px;\n  background: var(--mobile-bg-secondary);\n  border: 2px solid var(--mobile-border);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--mobile-text-primary);\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: center;\n}\n\n.preset-btn:hover {\n  border-color: var(--mobile-accent-blue);\n  background: rgba(33, 138, 255, 0.1);\n}\n\n.preset-btn.selected {\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  border-color: transparent;\n  color: white;\n  transform: scale(1.02);\n}\n\n.preset-btn:active {\n  transform: scale(0.98);\n}\n\n/* ========================================\n   EXPIRATION TIMEFRAME BUTTONS\n   ======================================== */\n\n.timeframe-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.timeframe-grid.grid-cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.timeframe-grid.grid-cols-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.timeframe-button {\n  position: relative;\n  padding: 20px 16px;\n  border-radius: 12px;\n  background: var(--mobile-bg-secondary);\n  border: 2px solid var(--mobile-border);\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s;\n  min-height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.timeframe-button:hover {\n  border-color: var(--mobile-accent-blue);\n  background: rgba(33, 138, 255, 0.05);\n  transform: translateY(-2px);\n}\n\n.timeframe-button.selected {\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  border-color: transparent;\n  color: white;\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.timeframe-button:active {\n  transform: scale(0.98);\n}\n\n.timeframe-icon {\n  font-size: 32px;\n}\n\n.timeframe-label {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n/* ========================================\n   STRATEGY CARDS (Basic Mode)\n   ======================================== */\n\n.strategy-card-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  padding: 0;\n}\n\n@media (min-width: 480px) {\n  .strategy-card-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 769px) {\n  .strategy-card-grid {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n  }\n}\n\n.strategy-card {\n  position: relative;\n  padding: 16px;\n  border-radius: 12px;\n  background: var(--mobile-bg-secondary);\n  border: 2px solid var(--mobile-border);\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.3s;\n  min-height: 120px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 8px;\n  color: var(--mobile-text-primary);\n}\n\n.strategy-card:hover {\n  border-color: rgba(33, 138, 255, 0.5);\n  background: rgba(33, 138, 255, 0.05);\n  transform: translateY(-2px);\n}\n\n.strategy-card.selected {\n  background: rgba(33, 138, 255, 0.15);\n  border-color: var(--mobile-accent-blue);\n  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);\n  transform: scale(1.02);\n}\n\n.strategy-card:active {\n  transform: scale(0.98);\n}\n\n.strategy-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Info button styling */\n.info-button {\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: 1px solid var(--mobile-border);\n  border-radius: 50%;\n  background: transparent;\n  color: var(--mobile-text-secondary);\n  font-size: 12px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.info-button:hover {\n  background: var(--mobile-accent-blue);\n  color: white;\n  border-color: var(--mobile-accent-blue);\n}\n\n/* Info overlay styling */\n.strategy-info-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(26, 26, 26, 0.98);\n  border-radius: 12px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  z-index: 10;\n}\n\n.info-content {\n  color: var(--mobile-text-primary);\n}\n\n.info-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: var(--mobile-bg-secondary);\n  color: var(--mobile-text-secondary);\n  border-radius: 50%;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.info-close:hover {\n  background: var(--mobile-accent-red);\n  color: white;\n}\n\n.info-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--mobile-accent-blue);\n  margin: 0 0 16px 0;\n}\n\n.info-item {\n  margin-bottom: 14px;\n}\n\n.info-item strong {\n  display: block;\n  font-size: 11px;\n  color: var(--mobile-accent-blue);\n  margin-bottom: 4px;\n  text-transform: uppercase;\n}\n\n.info-item p {\n  margin: 0;\n  font-size: 12px;\n  color: var(--mobile-text-secondary);\n  line-height: 1.4;\n}\n\n/* Ensure strategy card has relative positioning for overlay */\n.strategy-card {\n  position: relative;\n}\n\n.strategy-card-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--mobile-text-primary);\n  margin: 0;\n}\n\n.strategy-card-subtitle {\n  font-size: 12px;\n  color: var(--mobile-text-secondary);\n  margin: 0;\n  line-height: 1.4;\n  flex: 1;\n}\n\n.strategy-card-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.strategy-tag {\n  padding: 3px 8px;\n  border-radius: 4px;\n  background: rgba(33, 138, 255, 0.15);\n  color: var(--mobile-accent-blue);\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.strategy-card.selected .strategy-tag {\n  background: var(--mobile-accent-blue);\n  color: white;\n}\n\n.timeframe-range {\n  font-size: 11px;\n  opacity: 0.7;\n}\n\n/* Strategy card parameter grid */\n.strategy-params-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--mobile-border);\n}\n\n.param-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.param-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  opacity: 0.7;\n  letter-spacing: 0.5px;\n  color: var(--mobile-text-muted);\n}\n\n.param-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--mobile-text);\n}\n\n.param-value.expected-move {\n  color: var(--mobile-accent-blue);\n}\n\n/* Option type badge */\n.option-type-badge {\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.option-type-badge.call {\n  background: rgba(34, 197, 94, 0.2);\n  color: #22c55e;\n}\n\n.option-type-badge.put {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n/* Call vs Put strategy card styling */\n.strategy-card.call-strategy {\n  border-color: rgba(34, 197, 94, 0.3);\n}\n\n.strategy-card.call-strategy:hover {\n  border-color: rgba(34, 197, 94, 0.5);\n  background: rgba(34, 197, 94, 0.05);\n}\n\n.strategy-card.put-strategy {\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.strategy-card.put-strategy:hover {\n  border-color: rgba(239, 68, 68, 0.5);\n  background: rgba(239, 68, 68, 0.05);\n}\n\n/* Ensure cards have minimum height for parameter display */\n.strategy-card {\n  min-height: 200px;\n}\n\n/* Strategy card header adjustments */\n.strategy-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Strategy grid: 2 columns on desktop, 1 column on mobile */\n.strategy-card-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(2, 1fr); /* 2 columns on desktop */\n}\n\n/* Mobile: Single column layout for better readability */\n@media (max-width: 768px) {\n  .strategy-card-grid {\n    grid-template-columns: 1fr; /* Single column on mobile */\n    gap: 12px;\n  }\n\n  /* Hide subtitle on mobile for cleaner layout */\n  .strategy-card-subtitle {\n    display: none;\n  }\n\n  /* Adjust card styling for mobile */\n  .strategy-card {\n    padding: 14px;\n    min-height: auto; /* Remove height constraints */\n  }\n\n  .strategy-card-title {\n    font-size: 1em;\n  }\n\n  .strategy-params-grid .param-label {\n    font-size: 0.8em;\n  }\n\n  .strategy-params-grid .param-value {\n    font-size: 0.9em;\n  }\n}\n\n/* ========================================\n   Mode Toggle (Basic/Advanced)\n   ======================================== */\n\n.mode-toggle-grid {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n}\n\n@media (max-width: 640px) {\n  .mode-toggle-grid {\n    flex-direction: column;\n  }\n}\n\n.mode-toggle-card {\n  position: relative;\n  padding: 16px;\n  border-radius: 12px;\n  background: var(--mobile-bg-secondary);\n  border: 2px solid var(--mobile-border);\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.3s;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.mode-toggle-card:hover {\n  border-color: rgba(33, 138, 255, 0.5);\n  background: rgba(33, 138, 255, 0.05);\n  transform: translateY(-2px);\n}\n\n.mode-toggle-card.selected {\n  background: rgba(33, 138, 255, 0.15);\n  border-color: var(--mobile-accent-blue);\n  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);\n  transform: scale(1.02);\n}\n\n.mode-toggle-card:active {\n  transform: scale(0.98);\n}\n\n.mode-toggle-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--mobile-text-primary);\n  margin: 0;\n}\n\n.mode-toggle-subtitle {\n  font-size: 14px;\n  color: var(--mobile-text-secondary);\n  margin: 0;\n  line-height: 1.4;\n  opacity: 0.8;\n}\n\n.mode-toggle-card.selected .mode-toggle-title {\n  color: var(--mobile-text-primary); /* Keep text white in all states */\n}\n\n/* ========================================\n   SCREENER SPLIT-PANEL LAYOUT\n   ======================================== */\n\n.screener-layout-wrapper {\n  display: block;\n  width: 100%;\n}\n\n/* Desktop: Split panel layout */\n@media (min-width: 769px) {\n  .screener-layout-wrapper {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n    margin-top: 20px;\n  }\n\n  .screener-left-panel {\n    min-width: 0; /* Prevent grid blowout */\n  }\n\n  .screener-right-panel {\n    min-width: 0; /* Prevent grid blowout */\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  /* Ensure full-width queue section spans properly on desktop */\n  .queue-section-fullwidth {\n    grid-column: 1 / -1; /* Span full width */\n    width: 100%;\n  }\n}\n\n/* Mobile: Stacked layout */\n@media (max-width: 768px) {\n  .screener-layout-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .screener-left-panel {\n    width: 100%;\n  }\n\n  .screener-left-panel form {\n    margin-bottom: 8px;\n  }\n\n  .screener-right-panel {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n}\n\n/* Queue and Saved Parameters styling */\n.queue-section {\n  background: var(--mobile-surface);\n  border: 1px solid #3a3a3a;\n  border-radius: 12px;\n  overflow: hidden; /* For smooth collapse animation */\n}\n\n/* Screener Mode Section - collapsible with chevron and blue hover */\n.screener-mode-section {\n  background: var(--mobile-surface);\n  border: 1px solid #3a3a3a;\n  border-radius: 12px;\n  padding: 0;\n}\n\n.screener-mode-section .collapsible-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n  border-radius: 12px;\n}\n\n.screener-mode-section .collapsible-header:hover {\n  background-color: rgba(33, 138, 255, 0.1);\n}\n\n.screener-mode-section .collapsible-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.screener-mode-section .collapsible-header-left h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--mobile-text-primary);\n}\n\n.screener-mode-section .collapsible-header .chevron {\n  font-size: 20px;\n  color: var(--mobile-text-secondary);\n  transition: transform 0.3s ease;\n  display: inline-block;\n}\n\n.screener-mode-section .collapsible-header .chevron.rotate-90 {\n  transform: rotate(90deg);\n}\n\n.screener-mode-section .mode-summary {\n  font-size: 14px;\n  color: var(--mobile-accent-blue);\n  font-weight: 600;\n}\n\n.screener-mode-section .mode-toggle-content {\n  padding: 0 20px 20px 20px;\n}\n\n.saved-params-section {\n  background: var(--mobile-surface);\n  border: 1px solid #3a3a3a;\n  border-radius: 12px;\n  padding: 0; /* Remove padding, header handles it */\n}\n\n/* Saved params collapsible header - matches queue-header styling */\n.saved-params-section .collapsible-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n  border-radius: 12px;\n}\n\n.saved-params-section .collapsible-header:hover {\n  background-color: rgba(33, 138, 255, 0.1);\n}\n\n.saved-params-section .collapsible-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.saved-params-section .collapsible-header-left h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--mobile-text-primary);\n}\n\n.saved-params-section .collapsible-header .chevron {\n  font-size: 20px;\n  color: var(--mobile-text-secondary);\n  transition: transform 0.3s ease;\n  display: inline-block;\n}\n\n.saved-params-section .collapsible-header .chevron.rotate-90 {\n  transform: rotate(90deg);\n}\n\n.saved-params-section .saved-params-count {\n  font-size: 14px;\n  color: var(--mobile-accent-blue);\n  font-weight: 600;\n}\n\n/* When expanded, round only top corners of header */\n.saved-params-section.expanded .collapsible-header {\n  border-radius: 12px 12px 0 0;\n}\n\n/* Full-width queue section */\n.queue-section-fullwidth {\n  width: 100%;\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n\n/* Mobile: Reduce queue section spacing */\n@media (max-width: 768px) {\n  .queue-section-fullwidth {\n    margin-top: 12px;\n    margin-bottom: 16px;\n  }\n}\n\n.queue-section-fullwidth .queue-section {\n  width: 100%;\n  max-width: 100%;\n}\n\n/* Queue Header - Collapsible */\n.queue-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n  position: relative;\n}\n\n.queue-header:hover {\n  background-color: rgba(33, 138, 255, 0.1);\n}\n\n.queue-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.queue-header-left h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--mobile-text-primary);\n}\n\n/* Chevron for queue - reuse existing chevron styles */\n.queue-header .chevron {\n  font-size: 20px;\n  color: var(--mobile-text-secondary);\n  transition: transform 0.3s ease;\n  display: inline-block;\n}\n\n.queue-header .chevron.rotate-90 {\n  transform: rotate(90deg);\n}\n\n/* Queue header actions */\n.queue-header-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n/* Queue Content - Collapsible */\n.queue-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease, padding 0.3s ease;\n  padding: 0 20px;\n}\n\n.queue-content.expanded {\n  max-height: 2000px;\n  padding: 0 20px 20px 20px;\n}\n\n.saved-params-section h3 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--mobile-text-primary);\n}\n\n/* Scrollable saved params container (desktop) */\n.saved-params-list-container {\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #444 transparent;\n  padding: 0 20px 20px 20px; /* Add padding for content area */\n  max-height: 550px; /* Shows ~3.5 cards (140px each + 16px gap) */\n}\n\n/* Custom scrollbar for webkit browsers */\n.saved-params-list-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.saved-params-list-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.saved-params-list-container::-webkit-scrollbar-thumb {\n  background: #444;\n  border-radius: 3px;\n}\n\n.saved-params-list-container::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Saved parameters list - single column only */\n.saved-params-list {\n  display: grid;\n  grid-template-columns: 1fr !important; /* Force single column */\n  gap: 16px;\n  margin-top: 12px;\n}\n\n/* Saved parameter card specific styles */\n.saved-param-card {\n  /* Inherits queue-card base styles */\n  max-width: 100%; /* Ensure cards don't grow too large */\n}\n\n.saved-param-label {\n  padding: 6px 0 2px 0;\n  font-size: 11px;\n  color: var(--mobile-text-secondary);\n  border-top: 1px solid var(--mobile-border);\n  margin-top: 6px;\n  font-style: italic;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Queue items - Grid layout matching Watchlist Groups */\n.queue-list {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 16px;\n}\n\n/* Responsive grid breakpoints */\n@media (min-width: 640px) {\n  .queue-list {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .queue-list {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 1280px) {\n  .queue-list {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.queue-item {\n  background: var(--mobile-bg-secondary);\n  border: 1px solid var(--mobile-border);\n  border-radius: 8px;\n  padding: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.2s ease;\n}\n\n.queue-item:hover {\n  background: var(--mobile-surface-hover);\n  border-color: var(--mobile-accent-blue);\n}\n\n.queue-item-info {\n  flex: 1;\n}\n\n.queue-item-label {\n  font-weight: 600;\n  color: var(--mobile-text-primary);\n  margin-bottom: 4px;\n}\n\n.queue-item-details {\n  font-size: 12px;\n  color: var(--mobile-text-secondary);\n}\n\n.queue-item-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.queue-action-btn {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid var(--mobile-border);\n  background: var(--mobile-surface);\n  color: var(--mobile-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.queue-action-btn:hover {\n  background: var(--mobile-accent-blue);\n  border-color: var(--mobile-accent-blue);\n  color: white;\n}\n\n.queue-action-btn.remove {\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.queue-action-btn.remove:hover {\n  background: var(--mobile-accent-red);\n  border-color: var(--mobile-accent-red);\n}\n\n/* Queue Card - Strategy Card Style */\n.queue-card {\n  background: var(--mobile-bg-secondary);\n  border: 2px solid var(--mobile-border);\n  border-radius: 10px;\n  padding: 12px;\n  transition: all 0.3s ease;\n  min-height: 140px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.queue-card:hover {\n  background: var(--mobile-surface-hover);\n  border-color: var(--mobile-accent-blue);\n  transform: translateY(-2px);\n}\n\n/* Call/Put specific styling */\n.queue-card.call-card {\n  border-color: rgba(34, 197, 94, 0.3);\n}\n\n.queue-card.call-card:hover {\n  border-color: rgba(34, 197, 94, 0.5);\n  background: rgba(34, 197, 94, 0.05);\n}\n\n.queue-card.put-card {\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.queue-card.put-card:hover {\n  border-color: rgba(239, 68, 68, 0.5);\n  background: rgba(239, 68, 68, 0.05);\n}\n\n/* Queue Card Header */\n.queue-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.queue-card-tickers {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--mobile-text-primary);\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-right: 8px;\n}\n\n.queue-card-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* 2x2 Parameter Grid - Matches Strategy Cards */\n.queue-card-params-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid var(--mobile-border);\n  margin-bottom: 8px;\n}\n\n.queue-card-params-grid .param-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n}\n\n.queue-card-params-grid .param-label {\n  font-size: 8px;\n  text-transform: uppercase;\n  opacity: 0.7;\n  letter-spacing: 0.2px;\n  color: var(--mobile-text-muted);\n}\n\n.queue-card-params-grid .param-value {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--mobile-text-primary);\n}\n\n.queue-card-params-grid .param-value.expected-move {\n  color: var(--mobile-accent-blue);\n}\n\n/* Queue Card Actions */\n.queue-card-actions {\n  display: flex;\n  gap: 4px;\n  padding-top: 8px;\n  border-top: 1px solid var(--mobile-border);\n}\n\n.queue-card-actions button {\n  flex: 1;\n  padding: 4px 6px;\n  font-size: 11px;\n}\n\n/* Mobile adjustments for queue */\n@media (max-width: 768px) {\n  .queue-header {\n    padding: 12px 16px;\n  }\n\n  .detail-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n  }\n\n  .detail-label {\n    font-size: 11px;\n  }\n}\n\n/* ========================================\n   INLINE ACTION BUTTONS (For buttons inside cards)\n   ======================================== */\n\n.inline-action-btn {\n  padding: 6px 12px;\n  font-size: 12px;\n  border: 1px solid #333;\n  background-color: #1a1a1a;\n  color: #b0b0b0;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 500;\n  outline: none;\n}\n\n/* Primary variant (Load, Queue) */\n.inline-action-btn.inline-action-btn-primary:hover:not(:disabled) {\n  border-color: rgba(33, 138, 255, 0.5);\n  background-color: rgba(33, 138, 255, 0.15);\n  color: #fff;\n}\n\n.inline-action-btn.inline-action-btn-primary:active:not(:disabled) {\n  background-color: rgba(33, 138, 255, 0.25);\n  border-color: #218aff;\n}\n\n/* Danger variant (Delete, Remove) */\n.inline-action-btn.inline-action-btn-danger:hover:not(:disabled) {\n  border-color: #dc2626;\n  background-color: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n}\n\n.inline-action-btn.inline-action-btn-danger:active:not(:disabled) {\n  background-color: rgba(239, 68, 68, 0.25);\n  border-color: #ef4444;\n}\n\n/* Disabled state */\n.inline-action-btn:disabled,\n.inline-action-btn.inline-action-btn-disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Empty state */\n.empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  color: var(--mobile-text-muted);\n}\n\n.empty-state-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n  opacity: 0.5;\n}\n\n.empty-state-text {\n  font-size: 14px;\n}\n\n/* Save Parameter Button in Basic Form */\n.save-parameter-btn {\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.save-parameter-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n.save-parameter-btn:active {\n  transform: scale(0.98);\n}\n\n/* ========================================\n   FIXED BOTTOM BUTTON (Mobile)\n   ======================================== */\n\n.fixed-bottom-button {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 16px;\n  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));\n  background: rgba(10, 10, 10, 0.95);\n  backdrop-filter: blur(10px);\n  border-top: 1px solid var(--mobile-border);\n  z-index: 50;\n}\n\n.inline-button {\n  padding: 16px 0;\n  margin-top: 24px;\n}\n\n.run-screener-btn {\n  width: 100%;\n  padding: 16px 24px;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  color: white;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.run-screener-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);\n}\n\n.run-screener-btn:active {\n  transform: scale(0.98);\n}\n\n.run-screener-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: #666;\n  box-shadow: none;\n}\n\n.run-screener-btn.disabled:hover {\n  transform: none;\n}\n\n.queue-badge {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  background: #ef4444;\n  color: white;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 4px 8px;\n  border-radius: 12px;\n  border: 2px solid var(--mobile-bg-primary);\n  min-width: 24px;\n  text-align: center;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n/* ========================================\n   DIRECTION BUTTONS (Form)\n   ======================================== */\n\n.direction-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.direction-grid.grid-cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.direction-btn {\n  padding: 24px 16px;\n  border-radius: 12px;\n  background: var(--mobile-bg-secondary);\n  border: 2px solid var(--mobile-border);\n  cursor: pointer;\n  transition: all 0.3s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-height: 120px;\n}\n\n.direction-btn:hover {\n  border-color: var(--mobile-accent-blue);\n  background: rgba(33, 138, 255, 0.05);\n  transform: translateY(-2px);\n}\n\n.direction-btn.selected {\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  border-color: transparent;\n  color: white;\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.direction-btn:active {\n  transform: scale(0.98);\n}\n\n/* Direction buttons with theme template styling (matches mode-toggle cards) */\n.direction-btn-themed {\n  padding: 24px 16px;\n  border-radius: 12px;\n  background: #1f2937;\n  border: 2px solid #2d3748;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  min-height: 120px;\n}\n\n.direction-btn-themed:hover {\n  border-color: rgba(33, 138, 255, 0.5);\n  background: rgba(33, 138, 255, 0.05);\n  transform: translateY(-2px);\n}\n\n.direction-btn-themed.selected {\n  background: #218aff;\n  border-color: #218aff;\n  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);\n  transform: scale(1.02);\n}\n\n.direction-btn-themed.selected .direction-btn-subtitle {\n  color: rgba(255, 255, 255, 0.85);\n  opacity: 1;\n}\n\n.direction-btn-themed:active {\n  transform: scale(0.98);\n}\n\n.direction-btn-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--mobile-text-primary); /* Always white */\n  margin: 0;\n}\n\n.direction-btn-subtitle {\n  font-size: 14px;\n  color: var(--mobile-text-secondary);\n  opacity: 0.75;\n  margin: 0;\n}\n\n/* ========================================\n   TOUCH OPTIMIZATIONS (Mobile)\n   ======================================== */\n\n@media (max-width: 768px) {\n  /* Prevent iOS zoom on input focus */\n  input, select, textarea, button {\n    font-size: 16px !important;\n  }\n\n  /* Larger touch targets */\n  button, .button-like {\n    min-height: 44px;\n    min-width: 44px;\n  }\n\n  /* Prevent text selection on UI elements */\n  .section-header, .preset-btn, .timeframe-button, .direction-btn {\n    user-select: none;\n    -webkit-user-select: none;\n  }\n}\n\n/* ========================================\n   DESKTOP ENHANCEMENTS\n   ======================================== */\n\n@media (min-width: 769px) {\n  .accordion-section {\n    margin-bottom: 16px;\n  }\n\n  .section-header {\n    padding: 20px;\n  }\n\n  .slider-value-display {\n    font-size: 3rem;\n  }\n\n  .strike-slider::-webkit-slider-thumb,\n  .movement-slider::-webkit-slider-thumb {\n    width: 20px;\n    height: 20px;\n  }\n\n  .timeframe-button,\n  .direction-btn {\n    min-height: 140px;\n  }\n\n  .run-screener-btn {\n    max-width: 400px;\n    margin: 0 auto;\n  }\n}\n\n/* =============================================== */\n/* Instagram Stories Style Enhancements          */\n/* =============================================== */\n\n/* No-scroll constraint */\n.card-story-view.no-scroll {\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Grouped Progress Bar */\n.story-progress-grouped {\n  display: flex;\n  gap: 12px;\n  padding: env(safe-area-inset-top, 12px) 12px 12px;\n  background: linear-gradient(to bottom, rgba(0,0,0,0.9), transparent);\n  position: relative;\n  z-index: 10;\n}\n\n.ticker-progress-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.ticker-progress-group .ticker-label {\n  font-size: 9px;\n  color: rgba(255, 255, 255, 0.6);\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 2px;\n}\n\n.ticker-progress-group .progress-bars {\n  display: flex;\n  gap: 2px;\n}\n\n.ticker-progress-group .progress-segment {\n  flex: 1;\n  height: 3px;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n  position: relative;\n  overflow: hidden;\n}\n\n.ticker-progress-group .progress-segment.active {\n  background: #fff;\n  box-shadow: 0 0 4px rgba(255, 255, 255, 0.5);\n}\n\n.ticker-progress-group .progress-segment.passed {\n  background: rgba(255, 255, 255, 0.7);\n}\n\n/* Story Navigation Arrow Buttons - positioned below Greeks bar */\n.story-nav-arrows {\n  position: absolute;\n  bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 20px;\n  pointer-events: none;  /* Allow clicks to pass through container */\n  z-index: 20;\n}\n\n.story-nav-btn {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.6);\n  background: rgba(0, 0, 0, 0.5);\n  color: rgba(255, 255, 255, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  pointer-events: auto;  /* Enable clicks on buttons */\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.story-nav-btn:hover {\n  border-color: rgba(255, 255, 255, 0.8);\n  background: rgba(0, 0, 0, 0.6);\n}\n\n.story-nav-btn:active {\n  transform: scale(0.95);\n}\n\n.story-nav-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.story-nav-btn:disabled:active {\n  transform: none;\n}\n\n.story-nav-btn svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* Card Carousel Container - No scroll */\n.card-carousel-container {\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n  min-height: 0;  /* Allow flex item to shrink below content size */\n}\n\n.story-card-wrapper {\n  width: 100vw;\n  height: 100%;\n  max-height: 100%;  /* Constrain to parent */\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;  /* Clip any overflow */\n}\n\n/* Adjust ContractCard for no-scroll */\n.card-story-view.no-scroll .result-card-compact {\n  height: 100%;\n  max-height: 100%;  /* Constrain to parent */\n  overflow: hidden;  /* Clip any overflow - content should end at greeks-bar */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;  /* Distribute content evenly */\n  padding-top: 20px;\n  padding-bottom: env(safe-area-inset-bottom, 20px);\n  box-sizing: border-box;  /* Include padding in height calc */\n}\n\n.card-story-view.no-scroll .card-main-info {\n  flex-shrink: 0;\n  margin-bottom: 15px;\n}\n\n.card-story-view.no-scroll .key-metrics {\n  flex-shrink: 0;\n  margin-bottom: 15px;\n}\n\n.card-story-view.no-scroll .simulated-gain {\n  flex-shrink: 0;\n  margin-bottom: 15px;\n  padding: 20px;\n}\n\n.card-story-view.no-scroll .compact-controls {\n  flex-shrink: 0;\n  margin-bottom: 15px;\n  position: relative;\n  z-index: 10;  /* Ensure sliders are interactive */\n}\n\n.card-story-view.no-scroll .greeks-bar {\n  flex-shrink: 0;\n  margin-top: auto;\n}\n\n/* Reduce font sizes for compact layout */\n@media (max-height: 700px) {\n  .card-story-view.no-scroll .ticker-display {\n    font-size: 36px;\n  }\n\n  .card-story-view.no-scroll .metric-label {\n    font-size: 9px;\n  }\n\n  .card-story-view.no-scroll .metric-value {\n    font-size: 16px;\n  }\n\n  .card-story-view.no-scroll .gain-percentage {\n    font-size: 42px;\n  }\n\n  .card-story-view.no-scroll .greek-label {\n    font-size: 9px;\n  }\n\n  .card-story-view.no-scroll .greek-value {\n    font-size: 11px;\n  }\n}\n\n/* ============================================\n   MOBILE STORY VIEW FIX - AGGRESSIVE OVERRIDE\n   ============================================ */\n\n/* Lock page scroll when story view is open */\nbody.story-view-open,\nhtml.story-view-open {\n  overflow: hidden !important;\n  position: fixed !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n@media (max-width: 768px) {\n  /* Story view overlay - completely cover screen */\n  .card-story-view {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n    height: 100dvh !important;\n    background: #000000 !important;\n    z-index: 99999 !important;\n    overflow: hidden !important;\n  }\n\n  .card-story-view.show {\n    display: flex !important;\n    flex-direction: column !important;\n  }\n\n  .card-story-view.no-scroll {\n    height: 100vh !important;\n    height: 100dvh !important;\n    overflow: hidden !important;\n  }\n\n  /* Close button - fixed to viewport */\n  .card-story-view .card-close-btn {\n    position: fixed !important;\n    top: 12px !important;\n    right: 12px !important;\n    z-index: 100000 !important;\n    width: 40px !important;\n    height: 40px !important;\n    background: rgba(60, 60, 60, 0.95) !important;\n    border: 2px solid rgba(255, 255, 255, 0.5) !important;\n  }\n\n  /* Progress bar - minimal height */\n  .card-story-view .story-progress,\n  .card-story-view .story-progress-grouped {\n    flex-shrink: 0 !important;\n    padding: 8px 12px !important;\n  }\n\n  /* Carousel container - take remaining space */\n  .card-story-view .card-carousel-container {\n    flex: 1 !important;\n    min-height: 0 !important;\n    overflow: hidden !important;\n  }\n\n  /* Card wrapper */\n  .card-story-view .card-wrapper {\n    height: 100% !important;\n  }\n\n  /* Story card wrapper */\n  .card-story-view .story-card-wrapper {\n    height: 100% !important;\n    overflow: hidden !important;\n  }\n\n  /* Result card - constrained to fit viewport */\n  .card-story-view .result-card-compact {\n    height: 100% !important;\n    max-height: 100% !important;\n    overflow: hidden !important;\n    padding: 8px 12px env(safe-area-inset-bottom, 8px) !important;\n    justify-content: space-between !important;\n    gap: 8px !important;\n  }\n\n  /* Compact all internal elements */\n  .card-story-view .card-main-info {\n    margin-bottom: 8px !important;\n  }\n\n  .card-story-view .card-ticker-large {\n    font-size: 36px !important;\n  }\n\n  .card-story-view .key-metrics {\n    padding: 12px !important;\n    margin-bottom: 8px !important;\n  }\n\n  .card-story-view .metrics-grid {\n    gap: 10px !important;\n    margin-bottom: 12px !important;\n  }\n\n  .card-story-view .metric-item .metric-label-small {\n    font-size: 10px !important;\n  }\n\n  .card-story-view .metric-item .metric-value-large {\n    font-size: 16px !important;\n  }\n\n  .card-story-view .metric-highlight {\n    padding: 10px !important;\n  }\n\n  .card-story-view .gain-value {\n    font-size: 28px !important;\n  }\n\n  .card-story-view .compact-controls {\n    margin-bottom: 8px !important;\n    padding: 8px !important;\n  }\n\n  .card-story-view .control-row {\n    margin-bottom: 6px !important;\n  }\n\n  .card-story-view .refresh-data-btn {\n    padding: 8px 16px !important;\n    font-size: 12px !important;\n  }\n\n  .card-story-view .greeks-bar {\n    padding: 8px 12px !important;\n    margin-top: auto !important;\n  }\n}\n\n/* Stories View - Match GlobalSimulationControls styling */\n.card-story-view .control-value-inline {\n  color: #218aff;\n  font-weight: 700;\n  font-size: 11px;\n  min-width: auto;\n}\n\n.card-story-view .control-slider-inline {\n  height: 8px;\n  border-radius: 4px;\n}\n\n.card-story-view .refresh-data-btn {\n  background: #218aff;\n  box-shadow: none;\n}\n\n.card-story-view .refresh-data-btn:hover {\n  background: #1a6fcc;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Update Mode Toggle */\n.update-mode-toggle {\n  display: flex;\n  gap: 0;\n  margin-top: 12px;\n  margin-bottom: 8px;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid #333;\n}\n\n.update-mode-toggle .mode-btn {\n  flex: 1;\n  padding: 8px 12px;\n  background: #0a0a0a;\n  border: none;\n  color: #b0b0b0;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.update-mode-toggle .mode-btn.active {\n  background: rgba(33, 138, 255, 0.2);\n  color: #fff;\n}\n\n.update-mode-toggle .mode-btn:first-child {\n  border-right: 1px solid #333;\n}\n\n.update-mode-toggle .mode-btn:hover:not(.active) {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n/* Action Buttons Row */\n.card-action-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.card-action-buttons button {\n  flex: 1;\n}\n\n.card-action-buttons .refresh-data-btn {\n  margin-top: 0;\n}\n\n.card-action-buttons .reset-btn {\n  background: transparent;\n  border: 1px solid #666;\n  color: #b0b0b0;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.card-action-buttons .reset-btn:hover {\n  border-color: #888;\n  color: #fff;\n}\n\n.card-action-buttons .reset-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ============================================\n   FLOATING ACTION PANEL INTEGRATION\n   ============================================ */\n\n/* Adjust content padding when floating panel is present */\n@media (max-width: 768px) {\n  /* Ensure body doesn't interfere with fixed positioning */\n  body {\n    position: relative;\n    overflow-x: hidden;\n  }\n\n  .screener-layout-wrapper {\n    position: relative; /* Ensure fixed children can position correctly */\n    padding-bottom: calc(var(--mobile-panel-height) + 20px); /* Extra padding for breathing room */\n  }\n\n  /* Hide desktop saved params panel when on mobile (mobile uses swipeable views instead) */\n  .screener-right-panel {\n    display: none;\n  }\n\n  /* Ensure form sections have proper spacing */\n  .accordion-form-section {\n    margin-bottom: 12px;\n  }\n\n  /* Style accordion checkmarks for completed sections */\n  .accordion-form-section.completed .section-header::after {\n    content: '✓';\n    color: var(--mobile-accent-green);\n    font-size: 18px;\n    font-weight: bold;\n    margin-left: auto;\n  }\n\n  /* Smooth collapse animation for sections */\n  .accordion-form-section .section-content {\n    transition: max-height 0.3s ease, opacity 0.3s ease;\n  }\n\n  .accordion-form-section.collapsed .section-content {\n    max-height: 0;\n    opacity: 0;\n    overflow: hidden;\n  }\n\n  /* Ensure progress indicator is visible */\n  .progress-indicator {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    background: linear-gradient(\n      to bottom,\n      var(--mobile-bg-primary) 0%,\n      var(--mobile-bg-primary) 90%,\n      transparent 100%\n    );\n    padding: 12px 16px 16px;\n    margin: -12px -16px 12px;\n  }\n\n  /* Show buttons inline within mobile form panel */\n  .screener-mobile-form-panel .fixed-bottom-button {\n    display: block;\n    position: relative;\n    padding: 16px 0;\n    background: transparent;\n    border-top: none;\n    z-index: auto;\n  }\n\n  /* Ensure buttons container flows properly */\n  .screener-mobile-form-panel .fixed-bottom-button .flex {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .screener-mobile-form-panel .fixed-bottom-button button {\n    width: 100%;\n  }\n\n  /* Hide fixed buttons in other mobile contexts */\n  .fixed-bottom-button:not(.screener-mobile-form-panel .fixed-bottom-button) {\n    display: none;\n  }\n}\n\n/* ============================= */\n/* Action Button Template Styles */\n/* ============================= */\n\n/* Base action button styles */\n.action-btn {\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid #333;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 13px;\n  font-weight: 500;\n  background-color: #1f2937; /* Gray-800 like simulation settings */\n  outline: none;\n  position: relative;\n  color: #b0b0b0;\n}\n\n/* Primary variant */\n.action-btn-primary:hover:not(:disabled) {\n  border-color: #218aff;\n  background-color: #218aff;\n  color: #fff;\n}\n\n.action-btn-primary:active:not(:disabled) {\n  background-color: #1a6fcc;\n  border-color: #1a6fcc;\n}\n\n/* Solid-blue run variant — desktop Run button (matches mobile .msf-cta) */\n.action-btn-run-solid {\n  background-color: #218aff;\n  border-color: #218aff;\n  color: #fff;\n}\n\n.action-btn-run-solid:hover:not(:disabled) {\n  border-color: #1a6fcc;\n  background-color: #1a6fcc;\n  color: #fff;\n}\n\n.action-btn-run-solid:active:not(:disabled) {\n  background-color: #1a6fcc;\n  border-color: #1a6fcc;\n}\n\n/* Danger variant */\n.action-btn-danger:hover:not(:disabled) {\n  border-color: #ef4444;\n  background-color: #ef4444;\n  color: #fff;\n}\n\n.action-btn-danger:active:not(:disabled) {\n  background-color: #dc2626;\n  border-color: #dc2626;\n}\n\n/* Success variant - Uses blue like primary for Save button */\n.action-btn-success:hover:not(:disabled) {\n  border-color: #218aff;\n  background-color: #218aff;\n  color: #fff;\n}\n\n.action-btn-success:active:not(:disabled) {\n  background-color: #1a6fcc;\n  border-color: #1a6fcc;\n}\n\n/* Disabled state */\n.action-btn:disabled,\n.action-btn-disabled {\n  border-color: #333;\n  color: #666;\n  background-color: #1f2937;\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Queue badge for action buttons (inline version) */\n.action-btn .queue-badge-inline {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 6px;\n  margin-left: 8px;\n  background: #218aff;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 10px;\n  vertical-align: middle;\n}\n\n/* Tooltip styles */\n.action-btn-tooltip {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 8px;\n  padding: 4px 12px;\n  background-color: #111;\n  border: 1px solid #333;\n  border-radius: 4px;\n  color: #b0b0b0;\n  font-size: 12px;\n  white-space: nowrap;\n  z-index: 1000;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.action-btn-tooltip-visible,\n.action-btn:disabled:hover .action-btn-tooltip {\n  opacity: 1;\n}\n\n/* Run variant - Full width run scenarios button */\n.action-btn-run {\n  width: 100%;\n  margin-top: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 10px 20px;\n}\n\n.action-btn-run:hover:not(:disabled) {\n  border-color: #218aff;\n  background-color: #218aff;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(33, 138, 255, 0.2);\n  transform: translateY(-1px);\n}\n\n.action-btn-run:active:not(:disabled) {\n  background-color: #1a6fcc;\n  border-color: #1a6fcc;\n  transform: scale(0.98);\n}\n\n/* Floating panel run button specific styles */\n.floating-run-btn {\n  width: auto;\n  margin-top: 0;\n  padding: 8px 16px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.floating-run-btn .btn-icon,\n.floating-run-btn .btn-text {\n  display: inline-block;\n}\n\n.floating-run-btn .spinner-small {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n/* ============================================\n   MOBILE VIEW TOGGLE (Strategies / Saved Params)\n   ============================================ */\n\n/* Hidden on desktop */\n.mobile-view-toggle {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .mobile-view-toggle {\n    display: flex;\n    gap: 8px;\n    padding: 12px 16px;\n    background: var(--mobile-surface);\n    border: 1px solid var(--mobile-border);\n    border-radius: 10px;\n    margin-bottom: 12px;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n  }\n\n  .view-toggle-btn {\n    flex: 1;\n    padding: 10px 16px;\n    border: 2px solid var(--mobile-border);\n    background: transparent;\n    border-radius: 6px;\n    color: var(--mobile-text-secondary);\n    font-weight: 600;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n\n  .view-toggle-btn:hover {\n    border-color: rgba(33, 138, 255, 0.5);\n  }\n\n  .view-toggle-btn.active {\n    background: rgba(33, 138, 255, 0.15);\n    border-color: var(--mobile-accent-blue);\n    color: var(--mobile-text-primary);\n  }\n\n  .view-toggle-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 18px;\n    height: 18px;\n    padding: 0 6px;\n    margin-left: 6px;\n    background: var(--mobile-accent-blue);\n    color: white;\n    font-size: 11px;\n    font-weight: 600;\n    border-radius: 10px;\n  }\n\n  .swipe-hint {\n    position: absolute;\n    bottom: -18px;\n    left: 50%;\n    transform: translateX(-50%);\n    font-size: 10px;\n    color: var(--mobile-text-muted);\n    opacity: 0.7;\n  }\n}\n\n/* ============================================\n   MOBILE SWIPEABLE VIEWS CONTAINER\n   ============================================ */\n\n.mobile-swipeable-container {\n  display: flex;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none; /* Firefox */\n  /* Remove negative margin/padding that was causing misalignment */\n}\n\n.mobile-swipeable-container::-webkit-scrollbar {\n  display: none; /* Chrome, Safari */\n}\n\n.mobile-view-panel {\n  flex: 0 0 100%;\n  scroll-snap-align: start;\n  min-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Mobile form panel styling */\n.screener-mobile-form-panel {\n  /* No extra padding - let content align with toggle */\n}\n\n/* Mobile saved params panel styling */\n.screener-mobile-saved-panel {\n  padding-left: 8px;\n}\n\n.screener-mobile-saved-panel .saved-params-section {\n  background: var(--mobile-surface);\n  border: 1px solid var(--mobile-border);\n  border-radius: 12px;\n  padding: 0;\n  min-height: auto;\n}\n\n/* Compact saved params styling (matches accordion sections) */\n.saved-params-section.compact {\n  background: var(--mobile-surface);\n  border: 1px solid var(--mobile-border);\n  border-radius: 12px;\n  padding: 0;\n  overflow: hidden;\n}\n\n.saved-params-section.compact .collapsible-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.2s;\n}\n\n.saved-params-section.compact .collapsible-header:hover {\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.saved-params-section.compact .collapsible-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.saved-params-section.compact .collapsible-header h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--mobile-text-primary);\n}\n\n.saved-params-section.compact .saved-params-count {\n  font-size: 13px;\n  color: var(--mobile-accent-blue);\n  font-weight: 600;\n}\n\n.saved-params-section.compact .chevron {\n  font-size: 18px;\n  color: var(--mobile-text-muted);\n  transition: transform 0.3s ease;\n}\n\n.saved-params-section.compact.expanded {\n  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.15);\n  border-color: rgba(33, 138, 255, 0.3);\n}\n\n.saved-params-section.compact .saved-params-list {\n  padding: 0 16px 16px 16px;\n}\n\n.saved-params-section.compact .empty-state {\n  padding: 24px 16px;\n}\n\n/* ========================================\n   INTERMEDIATE MODE PRESET CARDS\n   ======================================== */\n\n/* Preset grid layout */\n.intermediate-preset-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-top: 12px;\n}\n\n/* Mobile: 2 columns */\n@media (max-width: 768px) {\n  .intermediate-preset-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n}\n\n/* Small mobile: still 2 columns but tighter */\n@media (max-width: 400px) {\n  .intermediate-preset-grid {\n    gap: 8px;\n  }\n}\n\n/* Preset card base styles */\n.intermediate-preset-card {\n  position: relative;\n  padding: 14px 12px;\n  border-radius: 10px;\n  border: 2px solid #2d3748;\n  background: #1f2937;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n  min-height: 70px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-family: inherit;\n  color: var(--mobile-text-primary);\n}\n\n.intermediate-preset-card:hover {\n  border-color: rgba(33, 138, 255, 0.5);\n  background: rgba(33, 138, 255, 0.05);\n  transform: translateY(-2px);\n}\n\n.intermediate-preset-card.selected {\n  border-color: #218aff;\n  background: #218aff;\n  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);\n}\n\n.intermediate-preset-card.selected .preset-card-description {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.intermediate-preset-card:active {\n  transform: scale(0.98);\n}\n\n/* Preset card content */\n.preset-card-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.preset-card-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--mobile-text-primary);\n  line-height: 1.2;\n}\n\n.preset-card-description {\n  font-size: 12px;\n  color: var(--mobile-text-secondary);\n  font-weight: 500;\n}\n\n/* Sentiment color coding for stock move presets */\n.intermediate-preset-card.sentiment-bullish {\n  border-color: rgba(34, 197, 94, 0.3);\n}\n\n.intermediate-preset-card.sentiment-bullish:hover {\n  border-color: rgba(34, 197, 94, 0.5);\n  background: rgba(34, 197, 94, 0.05);\n}\n\n.intermediate-preset-card.sentiment-bullish.selected {\n  border-color: #22c55e;\n  background: rgba(34, 197, 94, 0.15);\n  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);\n}\n\n.intermediate-preset-card.sentiment-bearish {\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.intermediate-preset-card.sentiment-bearish:hover {\n  border-color: rgba(239, 68, 68, 0.5);\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.intermediate-preset-card.sentiment-bearish.selected {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.15);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n/* Info button wrapper */\n.preset-info-wrapper {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n}\n\n.preset-info-button {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--mobile-text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n  font-style: italic;\n}\n\n.preset-info-button:hover {\n  background: rgba(33, 138, 255, 0.2);\n  border-color: rgba(33, 138, 255, 0.5);\n  color: var(--mobile-accent-blue);\n}\n\n/* Tooltip overlay */\n.preset-tooltip-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.preset-tooltip-content {\n  background: #1f2937;\n  border-radius: 12px;\n  padding: 20px;\n  max-width: 320px;\n  position: relative;\n  border: 1px solid var(--mobile-border);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n\n.preset-tooltip-content p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--mobile-text-secondary);\n}\n\n.preset-tooltip-close {\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  font-size: 20px;\n  color: var(--mobile-text-muted);\n  cursor: pointer;\n  transition: color 0.2s;\n  line-height: 1;\n}\n\n.preset-tooltip-close:hover {\n  color: var(--mobile-text-primary);\n}\n\n/* Section helper text */\n.section-helper-text {\n  font-size: 13px;\n  color: var(--mobile-text-secondary);\n  margin: 0 0 8px 0;\n  font-style: italic;\n}\n\n/* Mode toggle grid for 3 modes */\n.mode-toggle-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n@media (max-width: 768px) {\n  .mode-toggle-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
